// // import React, { useState, useEffect, useRef } from 'react';
// // import { ThreeDots } from 'react-loader-spinner';
// // import '@fortawesome/fontawesome-free/css/all.min.css';

// // const BotComponent = () => {
// //   const [isOpen, setIsOpen] = useState(false);
// //   const [messages, setMessages] = useState([]);
// //   const [inputText, setInputText] = useState('');
// //   const [loading, setLoading] = useState(false);
// //   const [userName, setUserName] = useState('');
// //   const [askingName, setAskingName] = useState(true);
// //   const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
// //   const [isSpeaking, setIsSpeaking] = useState(false);
// //   const [showSuggestions, setShowSuggestions] = useState(false);
// //   const [typingEffect, setTypingEffect] = useState({ active: false, text: '', fullText: '', speed: 30 });
// //   const messagesEndRef = useRef(null);
// //   const chatContainerRef = useRef(null);

// //   // LMS features data organized by category
// //   const lmsFeatures = {
// //     "Course Creation and Management": [
// //       "Creation of new courses with the ability to add, organize, and sequence different types of content",
// //       "Modification of existing courses with the ability to edit, add or remove content, change the sequence, etc",
// //       "Deletion of obsolete or unused courses to keep the platform relevant and updated",
// //       "A preview feature to view the course from a learner's perspective before publishing"
// //     ],
// //     "Learning Paths": [
// //       "Creation of learning paths, which are sequences of courses or topics that guide learners through a particular field or skill",
// //       "Personalization of learning paths, using AI to suggest courses based on user's profile, interests, past performance, etc",
// //       "Flexibility to adjust the learning paths based on feedback or changes in course availability"
// //     ],
// //     "Progress Tracking": [
// //       "Tracking feature for learners to visualize their own progress, including completed courses, ongoing courses, scored grades, etc",
// //       "Reporting features for educators/administrators to monitor learner progress and performance",
// //       "Automated notifications to learners when they reach milestones or complete learning paths"
// //     ],
// //     "Content Delivery": [
// //       "Support for multiple content formats such as text, video, audio, images, infographics, etc",
// //       "An interface that adapts to different devices, ensuring a seamless learning experience on mobiles, tablets, and computers"
// //     ],
// //     "Assessments and Quizzes": [
// //       "A built-in editor to create various types of assessments - MCQs, subjective questions, fill in the blanks, etc",
// //       "Auto-grading feature for objective assessments, providing instant feedback to learners",
// //       "Manual grading option for subjective questions, with the ability for teachers/mentors to provide personalized feedback"
// //     ],
// //     "Certification Management": [
// //       "Generation and issuing of certificates automatically upon course completion",
// //       "Option to customize certificate templates, including the design, logo, signature, etc",
// //       "Digital certificates with unique verification codes to prevent forgery"
// //     ],
// //     "Discussion Forums": [
// //       "Creation of course or topic-specific forums for learners to interact, discuss, and learn collaboratively",
// //       "A general forum for discussions that are not tied to specific courses",
// //       "Moderation tools to monitor discussions, resolve disputes, and maintain a positive learning environment"
// //     ],
// //     "AI Features": [
// //       "AI-Powered Tutoring with chatbots to answer common queries",
// //       "AI-driven content recommendations based on the user's interests",
// //       "AI-Powered Search capabilities to understand user queries and provide relevant results",
// //       "Personalized learning recommendations based on learner's profile"
// //     ]
// //   };

// //   // Quick reply suggestions
// //   const suggestions = [
// //     "Course Creation",
// //     "Learning Paths",
// //     "Assessment Tools",
// //     "AI Features",
// //     "Mobile Compatibility",
// //     "Certification"
// //   ];

// //   // Generate questions about LMS features
// //   const generateQuestions = () => {
// //     const questions = [
// //       `Hello ${userName}! Which of these LMS features would you like to learn more about first: Course Creation, Learning Paths, or Assessment Tools?`,
// //       `Thanks for sharing. Could you tell me what specific functionality you're looking for in a Learning Management System?`,
// //       `${userName}, what's your primary role? Are you an educator, administrator, or learner?`,
// //       `How important are AI-powered features like personalized recommendations and intelligent search to your LMS needs?`,
// //       `Would you prefer a cloud-based LMS or an on-premise solution for your organization?`,
// //       `Let's discuss certifications. Do you need to issue certificates to your learners when they complete courses?`,
// //       `What kinds of assessment tools would you need? Multiple choice quizzes, assignments, peer evaluations?`,
// //       `How important is mobile compatibility for your LMS requirements?`,
// //       `Would you like to incorporate social learning features like discussion forums and collaboration tools?`,
// //       `What reporting and analytics capabilities are you looking for in an LMS?`
// //     ];
// //     return questions;
// //   };

// //   // Generate detailed responses about LMS features
// //   const generateResponseForFeature = (feature) => {
// //     const featureResponses = {
// //       "course": "Our KaaS platform offers comprehensive Course Creation and Management tools including creating new courses with different content types, easy modification of existing courses, removal options for obsolete content, and a preview feature to see courses from a learner's perspective before publishing.",

// //       "learning path": "Learning Paths in our KaaS platform allow you to create sequences of courses that guide learners through particular skills. Our AI technology can personalize these paths based on user profiles and interests, and they're flexible enough to adjust based on feedback or course availability changes.",

// //       "assessment": "Our Assessment Tools include a built-in editor for creating various question types (MCQs, subjective questions, etc.), auto-grading features for objective assessments with instant feedback, and manual grading options for subjective questions where teachers can provide personalized feedback.",

// //       "certification": "VetLearn offers robust Certification Management with automatic certificate generation upon course completion, customizable certificate templates with your own design and branding, and secure digital certificates with unique verification codes to prevent forgery.",

// //       "ai": "VetLearn integrates several AI-powered features including intelligent tutoring with chatbots for answering queries, personalized content recommendations based on user interests, advanced search capabilities to understand complex queries, and learning recommendations tailored to each learner's profile.",

// //       "forum": "Our Discussion Forums feature allows creation of course-specific forums for collaborative learning, general forums for wider discussions, and powerful moderation tools to maintain a positive learning environment.",

// //       "mobile": "VetLearn provides fully responsive design ensuring your content works perfectly across all devices - desktops, tablets, and mobile phones. This creates a seamless learning experience regardless of how your users access the platform.",

// //       "analytics": "Our comprehensive analytics track user behavior, course performance, and community engagement with customizable, exportable reports and real-time analytics for up-to-date insights into your learning programs.",

// //       "cloud": "VetLearn uses a secure cloud-based architecture that's accessible anytime, anywhere via the internet. It's built on a scalable infrastructure to handle growing numbers of users and includes regular automatic updates.",

// //       "default": "I'd be happy to tell you more about any specific feature of our KaaS Learning Management System. You can ask about course creation tools, learning paths, assessment options, certification management, AI features, discussion forums, mobile compatibility, analytics, or our cloud architecture."
// //     };

// //     // Check which feature is mentioned
// //     const lowerFeature = feature.toLowerCase();
// //     for (const [key, response] of Object.entries(featureResponses)) {
// //       if (lowerFeature.includes(key)) {
// //         return response;
// //       }
// //     }

// //     return featureResponses.default;
// //   };

// //   // Typing effect for bot messages
// //   useEffect(() => {
// //     if (typingEffect.active && typingEffect.text.length < typingEffect.fullText.length) {
// //       const timer = setTimeout(() => {
// //         setTypingEffect(prev => ({
// //           ...prev,
// //           text: prev.fullText.substring(0, prev.text.length + 1)
// //         }));
// //       }, typingEffect.speed);
// //       return () => clearTimeout(timer);
// //     } else if (typingEffect.active && typingEffect.text.length === typingEffect.fullText.length) {
// //       setTypingEffect(prev => ({ ...prev, active: false }));
// //       // After typing is complete, show suggestions if appropriate
// //       if (!askingName && currentQuestionIndex === 1) {
// //         setShowSuggestions(true);
// //       }
// //     }
// //   }, [typingEffect, askingName, currentQuestionIndex]);

// //   // Scroll to bottom when messages change
// //   useEffect(() => {
// //     if (messagesEndRef.current) {
// //       messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
// //     }
// //   }, [messages, typingEffect.text]);

// //   // Initialize speech synthesis voices
// //   useEffect(() => {
// //     // Force voice list loading
// //     speechSynthesis.getVoices();
// //   }, []);

// //   const toggleChat = () => {
// //     setIsOpen(!isOpen);
// //     if (!isOpen) {
// //       // Reset conversation when opening
// //       setMessages([]);
// //       setAskingName(true);
// //       setUserName('');
// //       setCurrentQuestionIndex(0);
// //       setShowSuggestions(false);
// //     }
// //   };

// //   const speak = (text) => {
// //     if (isSpeaking) {
// //       speechSynthesis.cancel();
// //     }

// //     setIsSpeaking(true);
// //     const utterance = new SpeechSynthesisUtterance(text);
// //     utterance.lang = 'en-US';

// //     const voices = speechSynthesis.getVoices();
// //     const femaleVoice = voices.find(
// //       (voice) =>
// //         voice.name.includes('Female') ||
// //         voice.name.includes('Google US English Female') ||
// //         voice.name.includes('Samantha')
// //     );

// //     if (femaleVoice) {
// //       utterance.voice = femaleVoice;
// //     }

// //     utterance.onend = () => {
// //       setIsSpeaking(false);
// //     };

// //     speechSynthesis.speak(utterance);
// //   };

// //   useEffect(() => {
// //     if (isOpen) {
// //       const greetingMessage = {
// //         text: 'Hello, I am Ms.Kawan from KaaS Learning Management System. What is your name?',
// //         sender: 'bot',
// //       };
// //       setMessages([greetingMessage]);

// //       // Start typing effect
// //       setTypingEffect({
// //         active: true,
// //         text: '',
// //         fullText: greetingMessage.text,
// //         speed: 30
// //       });

// //       speak(greetingMessage.text);
// //     }
// //   }, [isOpen]);

// //   const processNameAndContinue = () => {
// //     if (inputText.trim() === '') return;

// //     // Add user's message to the chat
// //     const newMessage = {
// //       text: inputText,
// //       sender: 'user',
// //     };
// //     setMessages((prevMessages) => [...prevMessages, newMessage]);

// //     // Store the name
// //     setUserName(inputText);
// //     setAskingName(false);
// //     setInputText('');

// //     // Send a welcome message and the first question
// //     setTimeout(() => {
// //       const welcomeMessage = {
// //         text: `Nice to meet you, ${inputText}! I'd like to understand your Learning Management System needs better.`,
// //         sender: 'bot',
// //       };
// //       setMessages((prevMessages) => [...prevMessages, welcomeMessage]);

// //       // Start typing effect
// //       setTypingEffect({
// //         active: true,
// //         text: '',
// //         fullText: welcomeMessage.text,
// //         speed: 30
// //       });

// //       speak(welcomeMessage.text);

// //       setTimeout(() => {
// //         const firstQuestion = {
// //           text: generateQuestions()[0],
// //           sender: 'bot',
// //         };
// //         setMessages((prevMessages) => [...prevMessages, firstQuestion]);

// //         // Start typing effect for first question
// //         setTypingEffect({
// //           active: true,
// //           text: '',
// //           fullText: firstQuestion.text,
// //           speed: 30
// //         });

// //         speak(firstQuestion.text);
// //         setCurrentQuestionIndex(1);
// //       }, 2000);
// //     }, 1000);
// //   };

// //   const askNextQuestion = () => {
// //     const questions = generateQuestions();
// //     if (currentQuestionIndex < questions.length) {
// //       const nextQuestion = {
// //         text: questions[currentQuestionIndex],
// //         sender: 'bot',
// //       };
// //       setMessages((prevMessages) => [...prevMessages, nextQuestion]);

// //       // Start typing effect
// //       setTypingEffect({
// //         active: true,
// //         text: '',
// //         fullText: nextQuestion.text,
// //         speed: 30
// //       });

// //       speak(nextQuestion.text);
// //       setCurrentQuestionIndex(currentQuestionIndex + 1);
// //       setShowSuggestions(false);
// //     } else {
// //       // If we've gone through all questions, provide a summary
// //       const summaryMessage = {
// //         text: `Thank you for providing all this information, ${userName}. I can help you discover the perfect KaaS solution for your needs. Would you like me to prepare a customized LMS recommendation based on our conversation?`,
// //         sender: 'bot',
// //       };
// //       setMessages((prevMessages) => [...prevMessages, summaryMessage]);

// //       // Start typing effect
// //       setTypingEffect({
// //         active: true,
// //         text: '',
// //         fullText: summaryMessage.text,
// //         speed: 30
// //       });

// //       speak(summaryMessage.text);
// //     }
// //   };

// //   const sendMessage = () => {
// //     if (!inputText.trim()) return;
// //     setShowSuggestions(false);

// //     // Handle the name question separately
// //     if (askingName) {
// //       processNameAndContinue();
// //       return;
// //     }

// //     // Normal message flow
// //     const newMessage = {
// //       text: inputText,
// //       sender: 'user',
// //     };
// //     setMessages((prevMessages) => [...prevMessages, newMessage]);
// //     setLoading(true);

// //     // Generate a contextual response based on user input
// //     setTimeout(() => {
// //       const botResponse = {
// //         text: generateResponseForFeature(inputText),
// //         sender: 'bot',
// //       };
// //       setMessages((prevMessages) => [...prevMessages, botResponse]);

// //       // Start typing effect
// //       setTypingEffect({
// //         active: true,
// //         text: '',
// //         fullText: botResponse.text,
// //         speed: 30
// //       });

// //       speak(botResponse.text);
// //       setInputText('');
// //       setLoading(false);

// //       // Wait a moment and then ask the next question
// //       setTimeout(() => {
// //         askNextQuestion();
// //       }, 2500);
// //     }, 1000);
// //   };

// //   const handleKeyPress = (e) => {
// //     if (e.key === 'Enter') {
// //       sendMessage();
// //     }
// //   };

// //   const clearChat = () => {
// //     setMessages([]);
// //     setAskingName(true);
// //     setUserName('');
// //     setCurrentQuestionIndex(0);
// //     setShowSuggestions(false);

// //     // Add initial greeting again
// //     const greetingMessage = {
// //       text: 'Hello, I am Ms.Kawan from KaaS Learning Management System. What is your name?',
// //       sender: 'bot',
// //     };
// //     setMessages([greetingMessage]);

// //     // Start typing effect
// //     setTypingEffect({
// //       active: true,
// //       text: '',
// //       fullText: greetingMessage.text,
// //       speed: 30
// //     });

// //     speak(greetingMessage.text);
// //   };

// //   const handleSuggestionClick = (suggestion) => {
// //     setInputText(suggestion);
// //     setTimeout(() => {
// //       sendMessage();
// //     }, 100);
// //   };

// //   const toggleSpeech = () => {
// //     if (isSpeaking) {
// //       speechSynthesis.cancel();
// //       setIsSpeaking(false);
// //     } else {
// //       // Find the last bot message and speak it
// //       const lastBotMessage = [...messages].reverse().find(msg => msg.sender === 'bot');
// //       if (lastBotMessage) {
// //         speak(lastBotMessage.text);
// //       }
// //     }
// //   };

// //   // Bot avatar with animation
// //   const BotAvatar = () => (
// //     <div className="bot-avatar" style={{
// //       width: '40px',
// //       height: '40px',
// //       borderRadius: '50%',
// //       backgroundColor: '#8e44ad',
// //       display: 'flex',
// //       alignItems: 'center',
// //       justifyContent: 'center',
// //       position: 'relative',
// //       overflow: 'hidden',
// //       boxShadow: '0 2px 10px rgba(0,0,0,0.2)'
// //     }}>
// //       <div style={{
// //         width: '20px',
// //         height: '20px',
// //         borderRadius: '50%',
// //         backgroundColor: '#fff',
// //         position: 'relative',
// //         overflow: 'hidden'
// //       }}>
// //         <div style={{
// //           position: 'absolute',
// //           top: '50%',
// //           left: '50%',
// //           width: '10px',
// //           height: '10px',
// //           backgroundColor: '#8e44ad',
// //           borderRadius: '50%',
// //           transform: 'translate(-50%, -50%)',
// //           animation: isSpeaking ? 'pulse 1s infinite' : 'none'
// //         }} />
// //       </div>
// //       <style>{`
// //         @keyframes pulse {
// //           0% { transform: translate(-50%, -50%) scale(0.8); }
// //           50% { transform: translate(-50%, -50%) scale(1.2); }
// //           100% { transform: translate(-50%, -50%) scale(0.8); }
// //         }
// //       `}</style>
// //     </div>
// //   );

// //   return (
// //     <div
// //       style={{
// //         position: 'fixed',
// //         bottom: '20px',
// //         right: '20px',
// //         zIndex: 1000,
// //         fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif"
// //       }}
// //     >
// //       {!isOpen && (
// //         <div
// //           style={{
// //             backgroundColor: '#8e44ad',
// //             color: '#ffffff',
// //             padding: '15px',
// //             borderRadius: '50%',
// //             display: 'flex',
// //             alignItems: 'center',
// //             justifyContent: 'center',
// //             width: '60px',
// //             height: '60px',
// //             cursor: 'pointer',
// //             boxShadow: '0px 4px 15px rgba(0, 0, 0, 0.3)',
// //             transition: 'transform 0.3s ease, box-shadow 0.3s ease',
// //             animation: 'bounce 2s infinite'
// //           }}
// //           onClick={toggleChat}
// //           onMouseOver={(e) => {
// //             e.currentTarget.style.transform = 'scale(1.1)';
// //             e.currentTarget.style.boxShadow = '0px 6px 20px rgba(0, 0, 0, 0.4)';
// //           }}
// //           onMouseOut={(e) => {
// //             e.currentTarget.style.transform = 'scale(1)';
// //             e.currentTarget.style.boxShadow = '0px 4px 15px rgba(0, 0, 0, 0.3)';
// //           }}
// //         >
// //           <i className="fas fa-robot" style={{ fontSize: '24px' }}></i>
// //           <style>{`
// //             @keyframes bounce {
// //               0%, 100% { transform: translateY(0); }
// //               50% { transform: translateY(-10px); }
// //             }
// //           `}</style>
// //         </div>
// //       )}

// //       {isOpen && (
// //         <div
// //           style={{
// //             width: '350px',
// //             height: '550px',
// //             background: 'linear-gradient(135deg, #8e44ad, #9b59b6)',
// //             boxShadow: '0px 5px 25px rgba(0, 0, 0, 0.3)',
// //             borderRadius: '15px',
// //             overflow: 'hidden',
// //             display: 'flex',
// //             flexDirection: 'column',
// //             transition: 'all 0.3s ease',
// //             animation: 'slideIn 0.3s ease-out'
// //           }}
// //         >
// //           <style>{`
// //             @keyframes slideIn {
// //               from { opacity: 0; transform: translateY(20px); }
// //               to { opacity: 1; transform: translateY(0); }
// //             }
// //           `}</style>

// //           <div
// //             style={{
// //               background: 'rgba(0, 0, 0, 0.2)',
// //               backdropFilter: 'blur(10px)',
// //               color: '#ffffff',
// //               padding: '15px',
// //               display: 'flex',
// //               alignItems: 'center',
// //               justifyContent: 'space-between',
// //               borderTopLeftRadius: '15px',
// //               borderTopRightRadius: '15px',
// //               boxShadow: '0px 2px 10px rgba(0, 0, 0, 0.2)',
// //             }}
// //           >
// //             <div style={{ display: 'flex', alignItems: 'center' }}>
// //               <BotAvatar />
// //               <div style={{ marginLeft: '10px' }}>
// //                 <div style={{ fontWeight: 'bold', fontSize: '16px' }}>KaaS Assistant</div>
// //                 <div style={{ fontSize: '12px', opacity: 0.8 }}>
// //                   {isSpeaking ? 'Speaking...' : 'Online'}
// //                 </div>
// //               </div>
// //             </div>
// //             <div>
// //               <button
// //                 style={{
// //                   backgroundColor: 'rgba(255, 255, 255, 0.2)',
// //                   border: 'none',
// //                   color: '#ffffff',
// //                   cursor: 'pointer',
// //                   fontSize: '1em',
// //                   width: '30px',
// //                   height: '30px',
// //                   borderRadius: '50%',
// //                   display: 'inline-flex',
// //                   alignItems: 'center',
// //                   justifyContent: 'center',
// //                   marginRight: '8px',
// //                   transition: 'background-color 0.2s ease'
// //                 }}
// //                 onClick={toggleSpeech}
// //                 title={isSpeaking ? "Stop speaking" : "Speak message"}
// //               >
// //                 <i className={`fas ${isSpeaking ? 'fa-volume-mute' : 'fa-volume-up'}`}></i>
// //               </button>
// //               <button
// //                 style={{
// //                   backgroundColor: 'rgba(255, 255, 255, 0.2)',
// //                   border: 'none',
// //                   color: '#ffffff',
// //                   cursor: 'pointer',
// //                   fontSize: '1em',
// //                   width: '30px',
// //                   height: '30px',
// //                   borderRadius: '50%',
// //                   display: 'inline-flex',
// //                   alignItems: 'center',
// //                   justifyContent: 'center',
// //                   marginRight: '8px',
// //                   transition: 'background-color 0.2s ease'
// //                 }}
// //                 onClick={clearChat}
// //                 title="Clear chat"
// //               >
// //                 <i className="fas fa-trash"></i>
// //               </button>
// //               <button
// //                 style={{
// //                   backgroundColor: 'rgba(255, 255, 255, 0.2)',
// //                   border: 'none',
// //                   color: '#ffffff',
// //                   cursor: 'pointer',
// //                   fontSize: '1em',
// //                   width: '30px',
// //                   height: '30px',
// //                   borderRadius: '50%',
// //                   display: 'inline-flex',
// //                   alignItems: 'center',
// //                   justifyContent: 'center',
// //                   transition: 'background-color 0.2s ease'
// //                 }}
// //                 onClick={toggleChat}
// //                 title="Close chat"
// //               >
// //                 <i className="fas fa-times"></i>
// //               </button>
// //             </div>
// //           </div>

// //           <div
// //             ref={chatContainerRef}
// //             style={{
// //               flexGrow: 1,
// //               overflowY: 'auto',
// //               padding: '15px',
// //               display: 'flex',
// //               flexDirection: 'column',
// //               background: 'rgba(255, 255, 255, 0.9)',
// //               // backgroundImage: 'url("data:image/svg+xml,%3Csvg width=\'100\' height=\'100\' viewBox=\'0 0 100 100\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cpath d=\'M11 18c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm48 25c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm-43-7c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm63 31c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM34 90c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm56-76c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM12 86c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm28-65c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm23-11c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-6 60c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm29 22c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zM32 63c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm57-13c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-9-21c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM60 91c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM35 41c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM12 60c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2z\' fill=\'%239C92AC\' fillOpacity=\'0.05\' fillRule=\'evenodd\'/%3E%3C/svg%3E")',
// //             }}
// //           >
// //             {messages.map((message, index) => (
// //               <div
// //                 key={index}
// //                 style={{
// //                   alignSelf: message.sender === 'bot' ? 'flex-start' : 'flex-end',
// //                   marginBottom: '15px',
// //                   maxWidth: '80%',
// //                   animation: 'fadeIn 0.3s ease-out',
// //                 }}
// //               >
// //                 {message.sender === 'bot' && (
// //                   <div style={{
// //                     display: 'flex',
// //                     alignItems: 'flex-end',
// //                     marginBottom: '5px',
// //                   }}>
// //                     <BotAvatar />
// //                     <div style={{
// //                       fontSize: '0.8em',
// //                       color: '#8e44ad',
// //                       marginLeft: '5px',
// //                       fontWeight: 'bold'
// //                     }}>
// //                       Ms.Kawan
// //                     </div>
// //                   </div>
// //                 )}
// //                 <div
// //                   style={{
// //                     backgroundColor:
// //                       message.sender === 'bot' ? '#f5f5f5' : '#8e44ad',
// //                     color: message.sender === 'bot' ? '#333333' : '#ffffff',
// //                     padding: '12px 16px',
// //                     borderRadius: '18px',
// //                     borderTopLeftRadius: message.sender === 'bot' ? '4px' : '18px',
// //                     borderTopRightRadius: message.sender === 'bot' ? '18px' : '4px',
// //                     boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.1)',
// //                     wordBreak: 'break-word',
// //                     position: 'relative',
// //                     fontSize: '14px',
// //                     lineHeight: '1.5',
// //                   }}
// //                 >
// //                   {message === messages[messages.length - 1] && message.sender === 'bot' && typingEffect.active
// //                     ? typingEffect.text
// //                     : message.text}
// //                   {message === messages[messages.length - 1] && message.sender === 'bot' && typingEffect.active && (
// //                     <span className="typing-indicator" style={{ marginLeft: '4px' }}>
// //                       <span style={{ animation: 'blink 1s infinite' }}>.</span>
// //                       <span style={{ animation: 'blink 1s infinite 0.2s' }}>.</span>
// //                       <span style={{ animation: 'blink 1s infinite 0.4s' }}>.</span>
// //                       <style>{`
// //                         @keyframes blink {
// //                           0%, 100% { opacity: 0.2; }
// //                           50% { opacity: 1; }
// //                         }
// //                       `}</style>
// //                     </span>
// //                   )}
// //                 </div>
// //                 {message.sender === 'user' && (
// //                   <div style={{
// //                     fontSize: '0.8em',
// //                     color: '#8e44ad',
// //                     marginTop: '5px',
// //                     textAlign: 'right',
// //                     fontWeight: 'bold'
// //                   }}>
// //                     You
// //                   </div>
// //                 )}
// //               </div>
// //             ))}
// //             {loading && (
// //               <div style={{
// //                 alignSelf: 'flex-start',
// //                 marginLeft: '10px',
// //                 display: 'flex',
// //                 alignItems: 'center'
// //               }}>
// //                 <BotAvatar />
// //                 <div style={{ marginLeft: '10px' }}>
// //                   <ThreeDots
// //                     height='30'
// //                     width='50'
// //                     color='#8e44ad'
// //                     ariaLabel='loading'
// //                   />
// //                 </div>
// //               </div>
// //             )}
// //             {showSuggestions && (
// //               <div style={{
// //                 display: 'flex',
// //                 flexWrap: 'wrap',
// //                 gap: '8px',
// //                 marginTop: '10px',
// //                 marginBottom: '10px',
// //                 animation: 'fadeIn 0.5s ease-out',
// //               }}>
// //                 {suggestions.map((suggestion, index) => (
// //                   <button
// //                     key={index}
// //                     onClick={() => handleSuggestionClick(suggestion)}
// //                     style={{
// //                       backgroundColor: 'rgba(142, 68, 173, 0.1)',
// //                       border: '1px solid rgba(142, 68, 173, 0.3)',
// //                       borderRadius: '18px',
// //                       padding: '8px 12px',
// //                       fontSize: '13px',
// //                       color: '#8e44ad',
// //                       cursor: 'pointer',
// //                       transition: 'all 0.2s ease',
// //                     }}
// //                     onMouseOver={(e) => {
// //                       e.currentTarget.style.backgroundColor = 'rgba(142, 68, 173, 0.2)';
// //                     }}
// //                     onMouseOut={(e) => {
// //                       e.currentTarget.style.backgroundColor = 'rgba(142, 68, 173, 0.1)';
// //                     }}
// //                   >
// //                     {suggestion}
// //                   </button>
// //                 ))}
// //                 <style>{`
// //                   @keyframes fadeIn {
// //                     from { opacity: 0; transform: translateY(10px); }
// //                     to { opacity: 1; transform: translateY(0); }
// //                   }
// //                 `}</style>
// //               </div>
// //             )}
// //             <div ref={messagesEndRef} />
// //           </div>

// //           <div style={{
// //             padding: '15px',
// //             backgroundColor: 'rgba(255, 255, 255, 0.95)',
// //             borderTop: '1px solid rgba(0, 0, 0, 0.1)',
// //             boxShadow: '0px -2px 10px rgba(0, 0, 0, 0.05)'
// //           }}>
// //             <div
// //               style={{
// //                 display: 'flex',
// //                 alignItems: 'center',
// //                 borderRadius: '24px',
// //                 padding: '5px 15px',
// //                 backgroundColor: '#ffffff',
// //                 border: '1px solid #e0e0e0',
// //                 boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.05)',
// //                 transition: 'all 0.3s ease',
// //               }}
// //             >
// //               <input
// //                 type='text'
// //                 value={inputText}
// //                 onChange={(e) => setInputText(e.target.value)}
// //                 onKeyPress={handleKeyPress}
// //                 style={{
// //                   border: 'none',
// //                   outline: 'none',
// //                   flexGrow: 1,
// //                   backgroundColor: 'transparent',
// //                   padding: '12px 5px',
// //                   fontSize: '14px',
// //                 }}
// //                 placeholder={askingName ? 'Enter your name...' : 'Type your message...'}
// //               />
// //               <button
// //                 onClick={sendMessage}
// //                 style={{
// //                   backgroundColor: '#8e44ad',
// //                   color: '#ffffff',
// //                   border: 'none',
// //                   borderRadius: '50%',
// //                   width: '40px',
// //                   height: '40px',
// //                   display: 'flex',
// //                   alignItems: 'center',
// //                   justifyContent: 'center',
// //                   marginLeft: '10px',
// //                   cursor: 'pointer',
// //                   boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.2)',
// //                   transition: 'all 0.2s ease',
// //                 }}
// //                 onMouseOver={(e) => {
// //                   e.currentTarget.style.transform = 'scale(1.05)';
// //                   e.currentTarget.style.boxShadow = '0px 3px 8px rgba(0, 0, 0, 0.3)';
// //                 }}
// //                 onMouseOut={(e) => {
// //                   e.currentTarget.style.transform = 'scale(1)';
// //                   e.currentTarget.style.boxShadow = '0px 2px 5px rgba(0, 0, 0, 0.2)';
// //                 }}
// //               >
// //                 <i className='fas fa-paper-plane'></i>
// //               </button>
// //             </div>
// //             <div style={{
// //               textAlign: 'center',
// //               fontSize: '0.75em',
// //               color: '#8e44ad',
// //               marginTop: '10px',
// //               opacity: 0.7
// //             }}>
// //               KaaS Learning Management System © 2025
// //             </div>
// //           </div>
// //         </div>
// //       )}
// //     </div>
// //   );
// // };

// // export default BotComponent;

// import { useState, useEffect, useRef } from "react"
// import { ThreeDots } from "react-loader-spinner"
// import "@fortawesome/fontawesome-free/css/all.min.css"

// const KaaSChatbot = () => {
//   const [isOpen, setIsOpen] = useState(false)
//   const [messages, setMessages] = useState([])
//   const [inputText, setInputText] = useState("")
//   const [loading, setLoading] = useState(false)
//   const [userName, setUserName] = useState("")
//   const [askingName, setAskingName] = useState(true)
//   const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0)
//   const [isSpeaking, setIsSpeaking] = useState(false)
//   const [showSuggestions, setShowSuggestions] = useState(false)
//   const [typingEffect, setTypingEffect] = useState({ active: false, text: "", fullText: "", speed: 30 })
//   const messagesEndRef = useRef(null)
//   const chatContainerRef = useRef(null)

//   // KaaS features data organized by category
//   const KaaSFeatures = {
//     "Course Creation and Management": [
//       "Creation of expert-designed modules tailored to real-world technical courses in dairy, poultry, sheep & goat, swine and companion animal health",
//       "Modification of existing courses with practical, research-backed content from industry leaders",
//       "Deletion of obsolete content to keep the platform relevant and updated with latest industry practices",
//       "Preview feature to view courses from a learner's perspective before publishing to ensure quality delivery",
//     ],
//     "Learning Paths and Skill Development": [
//       "Creation of personalized learning journeys for entrepreneurship, productivity, and sustainability in animal health industries",
//       "Skill-based assessments and interactive modules designed to boost learner capabilities",
//       "Flexibility to adjust learning paths based on individual career and business objectives",
//       "Continuous upskilling programs for professional growth in livestock and companion animal sectors",
//     ],
//     "Progress Tracking and Analytics": [
//       "Comprehensive tracking of learning progress, completion rates, and assessment results",
//       "Data-driven insights to identify strengths, bridge gaps, and align learning with professional goals",
//       "Performance analytics for both learners and administrators to monitor development",
//       "Personalized recommendations based on learning patterns and career objectives",
//     ],
//     "Content Delivery and Accessibility": [
//       "24/7 access to interactive training resources with user-friendly platform design",
//       "Support for multiple content formats including practical case studies and research-driven materials",
//       "Mobile-responsive interface ensuring seamless learning experience across all devices",
//       "Integration with external tools and resources for comprehensive learning support",
//     ],
//     "Assessments and Certifications": [
//       "Practical assessments based on real-world scenarios in animal healthcare and nutrition",
//       "Professional certification programs recognized in the livestock and companion animal industry",
//       "Skill-based evaluations aligned with industry standards and best practices",
//       "Achievement recognition system to support career advancement and professional growth",
//     ],
//     "Community and Collaboration": [
//       "Connect and communicate with peers to learn from everyone's experience",
//       "Expert-led discussions and knowledge sharing sessions",
//       "Collaborative learning environment fostering professional networking",
//       "Access to industry professionals and seasoned experts for guidance and mentorship",
//     ],
//     "Entrepreneurship and Business Development": [
//       "Entrepreneurial readiness programs for livestock and companion animal industry opportunities",
//       "Business development modules focusing on making livestock farming simple and profitable",
//       "Industry insights and market analysis for informed decision-making",
//       "Practical business tools and case-based approaches for real-time problem solving",
//     ],
//     "Specialized Industry Focus": [
//       "Comprehensive coverage of dairy, poultry, sheep & goat, swine, and companion animal health sectors",
//       "Expert guidance from professionals with decades of hands-on experience",
//       "Research-backed content supported by leading veterinary experts and industry practitioners",
//       "Focus on enhancing pet health and happiness of pet parents in companion animal sector",
//     ],
//   }

//   // Quick reply suggestions
//   const suggestions = [
//     "Course Access",
//     "Learning Paths",
//     "Certifications",
//     "Industry Focus",
//     "Entrepreneurship",
//     "Progress Tracking",
//   ]

//   // Generate questions about KaaS features
//   const generateQuestions = () => {
//     const questions = [
//       `Hello ${userName}! Welcome to KaaS - your gateway to animal health expertise. Which area interests you most: Dairy, Poultry, Companion Animals, or Entrepreneurship?`,
//       `Great choice! What's your current role in the animal health industry? Are you a farmer, veterinarian, student, or looking to start your own venture?`,
//       `${userName}, what specific skills would you like to develop? We offer practical training in animal nutrition, health management, or business development.`,
//       `How important is hands-on, practical learning to you? Our courses are designed with real-world case studies and field experience.`,
//       `Would you be interested in earning professional certifications that are recognized in the livestock and companion animal industry?`,
//       `Are you looking to connect with other professionals and experts in the animal health field for collaborative learning?`,
//       `What's your primary goal: enhancing your current skills, starting an animal health business, or advancing your career?`,
//       `How do you prefer to learn? We offer 24/7 access with flexible scheduling, interactive modules, and expert-led sessions.`,
//       `Would you like to track your progress and receive personalized recommendations based on your learning journey?`,
//       `Are you interested in our specialized programs for making livestock farming more profitable and sustainable?`,
//     ]
//     return questions
//   }

//   // Generate detailed responses about KaaS features
//   const generateResponseForFeature = (feature) => {
//     const featureResponses = {
//       course:
//         "VetLearn offers expert-designed courses tailored to real-world applications in dairy, poultry, sheep & goat, swine, and companion animal health. All content is backed by research and taught by industry professionals with decades of hands-on experience.",
//       "learning path":
//         "Our personalized learning paths are designed to build entrepreneurship, boost productivity, and ensure sustainability in animal health industries. We use data-driven insights to create customized journeys that align with your career and business objectives.",
//       certification:
//         "VetLearn provides professional certifications recognized in the livestock and companion animal industry. Our achievement recognition system supports career advancement and validates your expertise in animal healthcare and nutrition.",
//       entrepreneurship:
//         "We focus on building entrepreneurial readiness with comprehensive business development modules. Our goal is to make livestock farming simple and profitable while enhancing pet health and happiness of pet parents.",
//       industry:
//         "VetLearn specializes in dairy, poultry, sheep & goat, swine, and companion animal health sectors. Our content is developed by experts who blend veterinary sciences, animal nutrition, and business development expertise.",
//       progress:
//         "Our platform tracks learning progress, completion rates, and assessment results to offer personalized insights. These analytics help identify strengths, bridge gaps, and align learning with your professional goals.",
//       practical:
//         "Every course emphasizes practical outcomes with real-world case studies and research conducted by leading veterinary experts. We blend experience with evidence-based knowledge for meaningful learning that enhances on-the-job performance.",
//       access:
//         "VetLearn provides 24/7 access to interactive training resources through a secure, user-friendly platform. You can learn anytime, anywhere with our mobile-responsive interface and comprehensive learning support.",
//       community:
//         "Connect, communicate, and learn from peers while gaining insights from industry experts. Our collaborative environment fosters professional networking and knowledge sharing in the animal health community.",
//       analytics:
//         "We enable data-driven learning with comprehensive analytics that track your performance and provide personalized recommendations. This empowers both learners and administrators to make informed decisions about professional development.",
//       support:
//         "For any support or assistance, you can contact us at KaaS@vetrinahealthcare.com or call us at +91 8600844450. Our team is always ready to help you with your learning journey.",
//       contact:
//         "You can reach out to us for support at KaaS@vetrinahealthcare.com or call us at +91 8600844450. We're here to assist you with any questions about KaaS platform and courses.",
//       help: "Need help? Contact our support team at KaaS@vetrinahealthcare.com or call +91 8600844450. We provide comprehensive support for all your learning needs on the KaaS platform.",
//       default:
//         "VetLearn is a hybrid learning platform designed to transform animal health education. We offer comprehensive training in dairy, poultry, sheep & goat, swine, and companion animal sectors, focusing on practical skills, entrepreneurship, and professional growth. For support, contact us at KaaS@vetrinahealthcare.com or +91 8600844450. How can I help you explore our specific features?",
//     }

//     // Check which feature is mentioned
//     const lowerFeature = feature.toLowerCase()
//     for (const [key, response] of Object.entries(featureResponses)) {
//       if (lowerFeature.includes(key)) {
//         return response
//       }
//     }
//     return featureResponses.default
//   }

//   // Typing effect for bot messages
//   useEffect(() => {
//     if (typingEffect.active && typingEffect.text.length < typingEffect.fullText.length) {
//       const timer = setTimeout(() => {
//         setTypingEffect((prev) => ({
//           ...prev,
//           text: prev.fullText.substring(0, prev.text.length + 1),
//         }))
//       }, typingEffect.speed)
//       return () => clearTimeout(timer)
//     } else if (typingEffect.active && typingEffect.text.length === typingEffect.fullText.length) {
//       setTypingEffect((prev) => ({ ...prev, active: false }))
//       // After typing is complete, show suggestions if appropriate
//       if (!askingName && currentQuestionIndex === 1) {
//         setShowSuggestions(true)
//       }
//     }
//   }, [typingEffect, askingName, currentQuestionIndex])

//   // Scroll to bottom when messages change
//   useEffect(() => {
//     if (messagesEndRef.current) {
//       messagesEndRef.current.scrollIntoView({ behavior: "smooth" })
//     }
//   }, [messages, typingEffect.text])

//   // Initialize speech synthesis voices
//   useEffect(() => {
//     // Force voice list loading
//     speechSynthesis.getVoices()
//   }, [])

//   const toggleChat = () => {
//     setIsOpen(!isOpen)
//     if (!isOpen) {
//       // Reset conversation when opening
//       setMessages([])
//       setAskingName(true)
//       setUserName("")
//       setCurrentQuestionIndex(0)
//       setShowSuggestions(false)
//     }
//   }

//   const speak = (text) => {
//     if (isSpeaking) {
//       speechSynthesis.cancel()
//     }
//     setIsSpeaking(true)
//     const utterance = new SpeechSynthesisUtterance(text)
//     utterance.lang = "en-US"
//     const voices = speechSynthesis.getVoices()
//     const femaleVoice = voices.find(
//       (voice) =>
//         voice.name.includes("Female") ||
//         voice.name.includes("Google US English Female") ||
//         voice.name.includes("Samantha"),
//     )
//     if (femaleVoice) {
//       utterance.voice = femaleVoice
//     }
//     utterance.onend = () => {
//       setIsSpeaking(false)
//     }
//     speechSynthesis.speak(utterance)
//   }

//   useEffect(() => {
//     if (isOpen) {
//       const greetingMessage = {
//         text: "Hello! I am Ms.Kawan from KaaS - your comprehensive learning platform for animal health and nutrition. What is your name?",
//         sender: "bot",
//       }
//       setMessages([greetingMessage])
//       // Start typing effect
//       setTypingEffect({
//         active: true,
//         text: "",
//         fullText: greetingMessage.text,
//         speed: 30,
//       })
//       speak(greetingMessage.text)
//     }
//   }, [isOpen])

//   const processNameAndContinue = () => {
//     if (inputText.trim() === "") return

//     // Add user's message to the chat
//     const newMessage = {
//       text: inputText,
//       sender: "user",
//     }
//     setMessages((prevMessages) => [...prevMessages, newMessage])

//     // Store the name
//     setUserName(inputText)
//     setAskingName(false)
//     setInputText("")

//     // Send a welcome message and the first question
//     setTimeout(() => {
//       const welcomeMessage = {
//         text: `Nice to meet you, ${inputText}! Welcome to KaaS - where we empower learning and enable growth in animal health industries. I'd like to understand your learning goals better.`,
//         sender: "bot",
//       }
//       setMessages((prevMessages) => [...prevMessages, welcomeMessage])
//       // Start typing effect
//       setTypingEffect({
//         active: true,
//         text: "",
//         fullText: welcomeMessage.text,
//         speed: 30,
//       })
//       speak(welcomeMessage.text)

//       setTimeout(() => {
//         const firstQuestion = {
//           text: generateQuestions()[0],
//           sender: "bot",
//         }
//         setMessages((prevMessages) => [...prevMessages, firstQuestion])
//         // Start typing effect for first question
//         setTypingEffect({
//           active: true,
//           text: "",
//           fullText: firstQuestion.text,
//           speed: 30,
//         })
//         speak(firstQuestion.text)
//         setCurrentQuestionIndex(1)
//       }, 2000)
//     }, 1000)
//   }

//   const askNextQuestion = () => {
//     const questions = generateQuestions()
//     if (currentQuestionIndex < questions.length) {
//       const nextQuestion = {
//         text: questions[currentQuestionIndex],
//         sender: "bot",
//       }
//       setMessages((prevMessages) => [...prevMessages, nextQuestion])
//       // Start typing effect
//       setTypingEffect({
//         active: true,
//         text: "",
//         fullText: nextQuestion.text,
//         speed: 30,
//       })
//       speak(nextQuestion.text)
//       setCurrentQuestionIndex(currentQuestionIndex + 1)
//       setShowSuggestions(false)
//     } else {
//       // If we've gone through all questions, provide a summary
//       const summaryMessage = {
//         text: `Thank you for sharing your interests, ${userName}! Based on our conversation, I can help you discover the perfect KaaS solution. Our platform offers 24/7 access to expert-designed courses, practical assessments, and professional certifications. For support, contact us at KaaS@vetrinahealthcare.com or +91 8600844450. Would you like me to guide you to our course catalog or help you get started with a specific learning path?`,
//         sender: "bot",
//       }
//       setMessages((prevMessages) => [...prevMessages, summaryMessage])
//       // Start typing effect
//       setTypingEffect({
//         active: true,
//         text: "",
//         fullText: summaryMessage.text,
//         speed: 30,
//       })
//       speak(summaryMessage.text)
//     }
//   }

//   const sendMessage = () => {
//     if (!inputText.trim()) return

//     setShowSuggestions(false)

//     // Handle the name question separately
//     if (askingName) {
//       processNameAndContinue()
//       return
//     }

//     // Normal message flow
//     const newMessage = {
//       text: inputText,
//       sender: "user",
//     }
//     setMessages((prevMessages) => [...prevMessages, newMessage])
//     setLoading(true)

//     // Generate a contextual response based on user input
//     setTimeout(() => {
//       const botResponse = {
//         text: generateResponseForFeature(inputText),
//         sender: "bot",
//       }
//       setMessages((prevMessages) => [...prevMessages, botResponse])
//       // Start typing effect
//       setTypingEffect({
//         active: true,
//         text: "",
//         fullText: botResponse.text,
//         speed: 30,
//       })
//       speak(botResponse.text)
//       setInputText("")
//       setLoading(false)

//       // Wait a moment and then ask the next question
//       setTimeout(() => {
//         askNextQuestion()
//       }, 2500)
//     }, 1000)
//   }

//   const handleKeyPress = (e) => {
//     if (e.key === "Enter") {
//       sendMessage()
//     }
//   }

//   const clearChat = () => {
//     setMessages([])
//     setAskingName(true)
//     setUserName("")
//     setCurrentQuestionIndex(0)
//     setShowSuggestions(false)

//     // Add initial greeting again
//     const greetingMessage = {
//       text: "Hello! I am Ms.Kawan from KaaS - your comprehensive learning platform for animal health and nutrition. What is your name?",
//       sender: "bot",
//     }
//     setMessages([greetingMessage])
//     // Start typing effect
//     setTypingEffect({
//       active: true,
//       text: "",
//       fullText: greetingMessage.text,
//       speed: 30,
//     })
//     speak(greetingMessage.text)
//   }

//   const handleSuggestionClick = (suggestion) => {
//     setInputText(suggestion)
//     setTimeout(() => {
//       sendMessage()
//     }, 100)
//   }

//   const toggleSpeech = () => {
//     if (isSpeaking) {
//       speechSynthesis.cancel()
//       setIsSpeaking(false)
//     } else {
//       // Find the last bot message and speak it
//       const lastBotMessage = [...messages].reverse().find((msg) => msg.sender === "bot")
//       if (lastBotMessage) {
//         speak(lastBotMessage.text)
//       }
//     }
//   }

//   // Bot avatar with animation
//   const BotAvatar = () => (
//     <div
//       className="bot-avatar"
//       style={{
//         width: "40px",
//         height: "40px",
//         borderRadius: "50%",
//         background: "linear-gradient(120deg, rgb(255, 102, 0) 0%, rgb(184, 82, 158) 100%)",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         position: "relative",
//         overflow: "hidden",
//         boxShadow: "0 2px 10px rgba(0,0,0,0.2)",
//       }}
//     >
//       <div
//         style={{
//           width: "20px",
//           height: "20px",
//           borderRadius: "50%",
//           backgroundColor: "#fff",
//           position: "relative",
//           overflow: "hidden",
//         }}
//       >
//         <div
//           style={{
//             position: "absolute",
//             top: "50%",
//             left: "50%",
//             width: "10px",
//             height: "10px",
//             background: "linear-gradient(120deg, rgb(255, 102, 0) 0%, rgb(184, 82, 158) 100%)",
//             borderRadius: "50%",
//             transform: "translate(-50%, -50%)",
//             animation: isSpeaking ? "pulse 1s infinite" : "none",
//           }}
//         />
//       </div>
//       <style>{`
//         @keyframes pulse {
//           0% { transform: translate(-50%, -50%) scale(0.8); }
//           50% { transform: translate(-50%, -50%) scale(1.2); }
//           100% { transform: translate(-50%, -50%) scale(0.8); }
//         }
//       `}</style>
//     </div>
//   )

//   return (
//     <div
//       style={{
//         position: "fixed",
//         bottom: "0px",
//         right: "20px",
//         zIndex: 1000,
//         fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
//       }}
//     >
//       {!isOpen && (
//         <div
//           style={{
//             background: "linear-gradient(120deg, rgb(255, 102, 0) 0%, rgb(184, 82, 158) 100%)",
//             color: "#ffffff",
//             padding: "15px",
//             borderRadius: "50%",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             width: "60px",
//             height: "60px",
//             cursor: "pointer",
//             boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.3)",
//             transition: "transform 0.3s ease, box-shadow 0.3s ease",
//             animation: "bounce 2s infinite",
//           }}
//           onClick={toggleChat}
//           onMouseOver={(e) => {
//             e.currentTarget.style.transform = "scale(1.1)"
//             e.currentTarget.style.boxShadow = "0px 6px 20px rgba(0, 0, 0, 0.4)"
//           }}
//           onMouseOut={(e) => {
//             e.currentTarget.style.transform = "scale(1)"
//             e.currentTarget.style.boxShadow = "0px 4px 15px rgba(0, 0, 0, 0.3)"
//           }}
//         >
//           <i className="fas fa-robot" style={{ fontSize: "24px" }}></i>
//           <style>{`
//             @keyframes bounce {
//               0%, 100% { transform: translateY(0); }
//               50% { transform: translateY(-10px); }
//             }
//           `}</style>
//         </div>
//       )}

//       {isOpen && (
//         <div
//           style={{
//             width: "350px",
//             height: "550px",
//             background: "linear-gradient(120deg, rgb(255, 102, 0) 0%, rgb(184, 82, 158) 100%)",
//             boxShadow: "0px 5px 25px rgba(0, 0, 0, 0.3)",
//             borderRadius: "15px",
//             overflow: "hidden",
//             display: "flex",
//             flexDirection: "column",
//             transition: "all 0.3s ease",
//             animation: "slideIn 0.3s ease-out",
//           }}
//         >
//           <style>{`
//             @keyframes slideIn {
//               from { opacity: 0; transform: translateY(20px); }
//               to { opacity: 1; transform: translateY(0); }
//             }
//           `}</style>

//           <div
//             style={{
//               background: "rgba(0, 0, 0, 0.2)",
//               backdropFilter: "blur(10px)",
//               color: "#ffffff",
//               padding: "15px",
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "space-between",
//               borderTopLeftRadius: "15px",
//               borderTopRightRadius: "15px",
//               boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.2)",
//             }}
//           >
//             <div style={{ display: "flex", alignItems: "center" }}>
//               <BotAvatar />
//               <div style={{ marginLeft: "10px" }}>
//                 <div style={{ fontWeight: "bold", fontSize: "16px" }}>KaaS Assistant</div>
//                 <div style={{ fontSize: "12px", opacity: 0.8 }}>{isSpeaking ? "Speaking..." : "Online"}</div>
//               </div>
//             </div>
//             <div>
//               <button
//                 style={{
//                   backgroundColor: "rgba(255, 255, 255, 0.2)",
//                   border: "none",
//                   color: "#ffffff",
//                   cursor: "pointer",
//                   fontSize: "1em",
//                   width: "30px",
//                   height: "30px",
//                   borderRadius: "50%",
//                   display: "inline-flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                   marginRight: "8px",
//                   transition: "background-color 0.2s ease",
//                 }}
//                 onClick={toggleSpeech}
//                 title={isSpeaking ? "Stop speaking" : "Speak message"}
//               >
//                 <i className={`fas ${isSpeaking ? "fa-volume-mute" : "fa-volume-up"}`}></i>
//               </button>
//               <button
//                 style={{
//                   backgroundColor: "rgba(255, 255, 255, 0.2)",
//                   border: "none",
//                   color: "#ffffff",
//                   cursor: "pointer",
//                   fontSize: "1em",
//                   width: "30px",
//                   height: "30px",
//                   borderRadius: "50%",
//                   display: "inline-flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                   marginRight: "8px",
//                   transition: "background-color 0.2s ease",
//                 }}
//                 onClick={clearChat}
//                 title="Clear chat"
//               >
//                 <i className="fas fa-trash"></i>
//               </button>
//               <button
//                 style={{
//                   backgroundColor: "rgba(255, 255, 255, 0.2)",
//                   border: "none",
//                   color: "#ffffff",
//                   cursor: "pointer",
//                   fontSize: "1em",
//                   width: "30px",
//                   height: "30px",
//                   borderRadius: "50%",
//                   display: "inline-flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                   transition: "background-color 0.2s ease",
//                 }}
//                 onClick={toggleChat}
//                 title="Close chat"
//               >
//                 <i className="fas fa-times"></i>
//               </button>
//             </div>
//           </div>

//           <div
//             ref={chatContainerRef}
//             style={{
//               flexGrow: 1,
//               overflowY: "auto",
//               padding: "15px",
//               display: "flex",
//               flexDirection: "column",
//               background: "rgba(255, 255, 255, 0.9)",
//             }}
//           >
//             {messages.map((message, index) => (
//               <div
//                 key={index}
//                 style={{
//                   alignSelf: message.sender === "bot" ? "flex-start" : "flex-end",
//                   marginBottom: "15px",
//                   maxWidth: "80%",
//                   animation: "fadeIn 0.3s ease-out",
//                 }}
//               >
//                 {message.sender === "bot" && (
//                   <div
//                     style={{
//                       display: "flex",
//                       alignItems: "flex-end",
//                       marginBottom: "5px",
//                     }}
//                   >
//                     <BotAvatar />
//                     <div
//                       style={{
//                         fontSize: "0.8em",
//                         color: "rgb(184, 82, 158)",
//                         marginLeft: "5px",
//                         fontWeight: "bold",
//                       }}
//                     >
//                       Ms.Kawan
//                     </div>
//                   </div>
//                 )}
//                 <div
//                   style={{
//                     backgroundColor:
//                       message.sender === "bot"
//                         ? "#f5f5f5"
//                         : "linear-gradient(120deg, rgb(255, 102, 0) 0%, rgb(184, 82, 158) 100%)",
//                     background:
//                       message.sender === "bot"
//                         ? "#f5f5f5"
//                         : "linear-gradient(120deg, rgb(255, 102, 0) 0%, rgb(184, 82, 158) 100%)",
//                     color: message.sender === "bot" ? "#333333" : "#ffffff",
//                     padding: "12px 16px",
//                     borderRadius: "18px",
//                     borderTopLeftRadius: message.sender === "bot" ? "4px" : "18px",
//                     borderTopRightRadius: message.sender === "bot" ? "18px" : "4px",
//                     boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)",
//                     wordBreak: "break-word",
//                     position: "relative",
//                     fontSize: "14px",
//                     lineHeight: "1.5",
//                   }}
//                 >
//                   {message === messages[messages.length - 1] && message.sender === "bot" && typingEffect.active
//                     ? typingEffect.text
//                     : message.text}
//                   {message === messages[messages.length - 1] && message.sender === "bot" && typingEffect.active && (
//                     <span className="typing-indicator" style={{ marginLeft: "4px" }}>
//                       <span style={{ animation: "blink 1s infinite" }}>.</span>
//                       <span style={{ animation: "blink 1s infinite 0.2s" }}>.</span>
//                       <span style={{ animation: "blink 1s infinite 0.4s" }}>.</span>
//                       <style>{`
//                         @keyframes blink {
//                           0%, 100% { opacity: 0.2; }
//                           50% { opacity: 1; }
//                         }
//                       `}</style>
//                     </span>
//                   )}
//                 </div>
//                 {message.sender === "user" && (
//                   <div
//                     style={{
//                       fontSize: "0.8em",
//                       color: "rgb(184, 82, 158)",
//                       marginTop: "5px",
//                       textAlign: "right",
//                       fontWeight: "bold",
//                     }}
//                   >
//                     You
//                   </div>
//                 )}
//               </div>
//             ))}

//             {loading && (
//               <div
//                 style={{
//                   alignSelf: "flex-start",
//                   marginLeft: "10px",
//                   display: "flex",
//                   alignItems: "center",
//                 }}
//               >
//                 <BotAvatar />
//                 <div style={{ marginLeft: "10px" }}>
//                   <ThreeDots height="30" width="50" color="rgb(184, 82, 158)" ariaLabel="loading" />
//                 </div>
//               </div>
//             )}

//             {showSuggestions && (
//               <div
//                 style={{
//                   display: "flex",
//                   flexWrap: "wrap",
//                   gap: "8px",
//                   marginTop: "10px",
//                   marginBottom: "10px",
//                   animation: "fadeIn 0.5s ease-out",
//                 }}
//               >
//                 {suggestions.map((suggestion, index) => (
//                   <button
//                     key={index}
//                     onClick={() => handleSuggestionClick(suggestion)}
//                     style={{
//                       backgroundColor: "rgba(184, 82, 158, 0.1)",
//                       border: "1px solid rgba(184, 82, 158, 0.3)",
//                       borderRadius: "18px",
//                       padding: "8px 12px",
//                       fontSize: "13px",
//                       color: "rgb(184, 82, 158)",
//                       cursor: "pointer",
//                       transition: "all 0.2s ease",
//                     }}
//                     onMouseOver={(e) => {
//                       e.currentTarget.style.backgroundColor = "rgba(184, 82, 158, 0.2)"
//                     }}
//                     onMouseOut={(e) => {
//                       e.currentTarget.style.backgroundColor = "rgba(184, 82, 158, 0.1)"
//                     }}
//                   >
//                     {suggestion}
//                   </button>
//                 ))}
//                 <style>{`
//                   @keyframes fadeIn {
//                     from { opacity: 0; transform: translateY(10px); }
//                     to { opacity: 1; transform: translateY(0); }
//                   }
//                 `}</style>
//               </div>
//             )}
//             <div ref={messagesEndRef} />
//           </div>

//           <div
//             style={{
//               padding: "15px",
//               backgroundColor: "rgba(255, 255, 255, 0.95)",
//               borderTop: "1px solid rgba(0, 0, 0, 0.1)",
//               boxShadow: "0px -2px 10px rgba(0, 0, 0, 0.05)",
//             }}
//           >
//             <div
//               style={{
//                 display: "flex",
//                 alignItems: "center",
//                 borderRadius: "24px",
//                 padding: "5px 15px",
//                 backgroundColor: "#ffffff",
//                 border: "1px solid #e0e0e0",
//                 boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.05)",
//                 transition: "all 0.3s ease",
//               }}
//             >
//               <input
//                 type="text"
//                 value={inputText}
//                 onChange={(e) => setInputText(e.target.value)}
//                 onKeyPress={handleKeyPress}
//                 style={{
//                   border: "none",
//                   outline: "none",
//                   flexGrow: 1,
//                   backgroundColor: "transparent",
//                   padding: "12px 5px",
//                   fontSize: "14px",
//                 }}
//                 placeholder={askingName ? "Enter your name..." : "Type your message..."}
//               />
//               <button
//                 onClick={sendMessage}
//                 style={{
//                   background: "linear-gradient(120deg, rgb(255, 102, 0) 0%, rgb(184, 82, 158) 100%)",
//                   color: "#ffffff",
//                   border: "none",
//                   borderRadius: "50%",
//                   width: "40px",
//                   height: "40px",
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                   marginLeft: "10px",
//                   cursor: "pointer",
//                   boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.2)",
//                   transition: "all 0.2s ease",
//                 }}
//                 onMouseOver={(e) => {
//                   e.currentTarget.style.transform = "scale(1.05)"
//                   e.currentTarget.style.boxShadow = "0px 3px 8px rgba(0, 0, 0, 0.3)"
//                 }}
//                 onMouseOut={(e) => {
//                   e.currentTarget.style.transform = "scale(1)"
//                   e.currentTarget.style.boxShadow = "0px 2px 5px rgba(0, 0, 0, 0.2)"
//                 }}
//               >
//                 <i className="fas fa-paper-plane"></i>
//               </button>
//             </div>
//             <div
//               style={{
//                 textAlign: "center",
//                 fontSize: "0.75em",
//                 color: "rgb(184, 82, 158)",
//                 marginTop: "10px",
//                 opacity: 0.7,
//               }}
//             >
//               KaaS - Empowering Learning. Enabling Growth. © 2025
//             </div>
//             <div
//               style={{
//                 textAlign: "center",
//                 fontSize: "0.7em",
//                 color: "#666",
//                 marginTop: "5px",
//               }}
//             >
//               <b>Contact: KaaS@vetrinahealthcare.com | +91 8600844450</b>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   )
// }

// export default KaaSChatbot

// import { useState, useEffect, useRef } from "react"
// import { ThreeDots } from "react-loader-spinner"
// import "@fortawesome/fontawesome-free/css/all.min.css"
// import axios from "axios" // <-- Added for API calls

// // +------------------------------------------------------------------+
// // |  Component for Rendering Structured JSON from the Diagnostic API |
// // +------------------------------------------------------------------+
// const ParsedJsonResponse = ({ data }) => {
//   const [isExpanded, setIsExpanded] = useState(false)
//   const { answer, possible_causes, tools_required, parts_needed, fault_code, system, description, repair_steps } = data

//   const hasDetailsToShow =
//     (possible_causes && possible_causes.length > 0) ||
//     (tools_required && tools_required.length > 0) ||
//     (parts_needed && parts_needed.length > 0) ||
//     (repair_steps && repair_steps.length > 0)

//   const DetailSection = ({ title, icon, items }) => {
//     if (!items || !Array.isArray(items) || items.length === 0) {
//       return null
//     }
//     return (
//       <div style={{ marginBottom: "12px" }}>
//         <h4 style={{ margin: "0 0 6px 0", color: "#b8529e", fontSize: "0.8rem", textTransform: "uppercase", display: "flex", alignItems: "center" }}>
//           <i className={`fas ${icon}`} style={{ marginRight: "6px" }}></i>
//           {title}
//         </h4>
//         <ul style={{ listStyle: "none", paddingLeft: "0", margin: "0" }}>
//           {items.map((item, idx) => (
//             <li key={idx} style={{ padding: "2px 0 2px 18px", position: "relative" }}>
//               <span style={{ position: "absolute", left: "4px", color: "#ff6600", fontWeight: "bold" }}>›</span>
//               {item}
//             </li>
//           ))}
//         </ul>
//       </div>
//     )
//   }

//   return (
//     <div style={{ background: "white", border: "1px solid #e0e0e0", borderRadius: "12px", fontSize: "0.9rem", width: "100%", boxShadow: "0 2px 4px rgba(0,0,0,0.05)" }}>
//       <div style={{ padding: "12px" }}>
//         {answer && <p style={{ margin: "0 0 4px 0", fontSize: "0.9rem", lineHeight: "1.4" }}><strong style={{ color: "#333" }}>Answer:</strong> {answer}</p>}
//         {fault_code && <p style={{ margin: "0 0 4px 0", fontSize: "0.9rem", lineHeight: "1.4" }}><strong style={{ color: "#333" }}>Fault Code:</strong> {fault_code}</p>}
//         {system && <p style={{ margin: "0 0 4px 0", fontSize: "0.9rem", lineHeight: "1.4" }}><strong style={{ color: "#333" }}>System:</strong> {system}</p>}
//         {description && <p style={{ margin: "0 0 4px 0", fontSize: "0.9rem", lineHeight: "1.4" }}><strong style={{ color: "#333" }}>Description:</strong> {description}</p>}
//       </div>
//       {isExpanded && (
//         <div style={{ padding: "12px", fontSize: "0.85rem", maxHeight: "200px", overflowY: "auto", borderTop: "1px solid #e9ecef" }}>
//           <DetailSection title="Possible Causes" icon="fa-exclamation-triangle" items={possible_causes} />
//           <DetailSection title="Tools Required" icon="fa-wrench" items={tools_required} />
//           <DetailSection title="Parts Needed" icon="fa-cogs" items={parts_needed} />
//           <DetailSection title="Repair Steps" icon="fa-clipboard-list" items={repair_steps} />
//         </div>
//       )}
//       {hasDetailsToShow && (
//         <button
//           style={{ backgroundColor: "#f8f9fa", border: "none", color: "#495057", width: "100%", textAlign: "center", padding: "8px", borderRadius: "0 0 11px 11px", cursor: "pointer", fontWeight: "500", fontSize: "0.8rem", transition: "background-color 0.2s", borderTop: "1px solid #e9ecef" }}
//           onClick={() => setIsExpanded(!isExpanded)}
//         >
//           {isExpanded ? 'Hide Full Analysis' : 'Show Full Analysis'}
//         </button>
//       )}
//     </div>
//   )
// }

// const KaaSChatbot = () => {
//   // --- EXISTING KaaS STATES ---
//   const [isOpen, setIsOpen] = useState(false)
//   const [messages, setMessages] = useState([])
//   const [inputText, setInputText] = useState("")
//   const [loading, setLoading] = useState(false)
//   const [userName, setUserName] = useState("")
//   const [askingName, setAskingName] = useState(true)
//   const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0)
//   const [isSpeaking, setIsSpeaking] = useState(false)
//   const [showSuggestions, setShowSuggestions] = useState(false)
//   const [typingEffect, setTypingEffect] = useState({ active: false, text: "", fullText: "", speed: 30 })
//   const messagesEndRef = useRef(null)
//   const chatContainerRef = useRef(null)
//   const fileInputRef = useRef(null) // <-- Ref for file input

//   // --- NEW STATES FOR API FUNCTIONALITY ---
//   const [pdfId, setPdfId] = useState(null)
//   const [chatMode, setChatMode] = useState("general") // 'general' or 'pdf_qa'

//   // KaaS features data organized by category
//   const KaaSFeatures = {
//     "Course Creation and Management": [
//       "Creation of expert-designed modules tailored to real-world technical courses in dairy, poultry, sheep & goat, swine and companion animal health",
//       "Modification of existing courses with practical, research-backed content from industry leaders",
//       "Deletion of obsolete content to keep the platform relevant and updated with latest industry practices",
//       "Preview feature to view courses from a learner's perspective before publishing to ensure quality delivery",
//     ],
//     "Learning Paths and Skill Development": [
//       "Creation of personalized learning journeys for entrepreneurship, productivity, and sustainability in animal health industries",
//       "Skill-based assessments and interactive modules designed to boost learner capabilities",
//       "Flexibility to adjust learning paths based on individual career and business objectives",
//       "Continuous upskilling programs for professional growth in livestock and companion animal sectors",
//     ],
//     "Progress Tracking and Analytics": [
//       "Comprehensive tracking of learning progress, completion rates, and assessment results",
//       "Data-driven insights to identify strengths, bridge gaps, and align learning with professional goals",
//       "Performance analytics for both learners and administrators to monitor development",
//       "Personalized recommendations based on learning patterns and career objectives",
//     ],
//     "Content Delivery and Accessibility": [
//       "24/7 access to interactive training resources with user-friendly platform design",
//       "Support for multiple content formats including practical case studies and research-driven materials",
//       "Mobile-responsive interface ensuring seamless learning experience across all devices",
//       "Integration with external tools and resources for comprehensive learning support",
//     ],
//     "Assessments and Certifications": [
//       "Practical assessments based on real-world scenarios in animal healthcare and nutrition",
//       "Professional certification programs recognized in the livestock and companion animal industry",
//       "Skill-based evaluations aligned with industry standards and best practices",
//       "Achievement recognition system to support career advancement and professional growth",
//     ],
//     "Community and Collaboration": [
//       "Connect and communicate with peers to learn from everyone's experience",
//       "Expert-led discussions and knowledge sharing sessions",
//       "Collaborative learning environment fostering professional networking",
//       "Access to industry professionals and seasoned experts for guidance and mentorship",
//     ],
//     "Entrepreneurship and Business Development": [
//       "Entrepreneurial readiness programs for livestock and companion animal industry opportunities",
//       "Business development modules focusing on making livestock farming simple and profitable",
//       "Industry insights and market analysis for informed decision-making",
//       "Practical business tools and case-based approaches for real-time problem solving",
//     ],
//     "Specialized Industry Focus": [
//       "Comprehensive coverage of dairy, poultry, sheep & goat, swine, and companion animal health sectors",
//       "Expert guidance from professionals with decades of hands-on experience",
//       "Research-backed content supported by leading veterinary experts and industry practitioners",
//       "Focus on enhancing pet health and happiness of pet parents in companion animal sector",
//     ],
//   }

//   // Quick reply suggestions
//   const suggestions = ["Course Access", "Learning Paths", "Certifications", "Industry Focus", "Entrepreneurship", "Progress Tracking"]

//   // Generate questions about KaaS features
//   const generateQuestions = () => {
//     return [
//       `Hello ${userName || "there"}! Welcome to KaaS. Which area interests you most: Dairy, Poultry, Companion Animals, or Entrepreneurship? Or, you can upload a document for analysis.`,
//       `Great choice! What's your current role in the animal health industry? Are you a farmer, veterinarian, student, or looking to start your own venture?`,
//       `${userName}, what specific skills would you like to develop? We offer practical training in animal nutrition, health management, or business development.`,
//       `How important is hands-on, practical learning to you? Our courses are designed with real-world case studies and field experience.`,
//       `Would you be interested in earning professional certifications that are recognized in the livestock and companion animal industry?`,
//       `Are you looking to connect with other professionals and experts in the animal health field for collaborative learning?`,
//       `What's your primary goal: enhancing your current skills, starting an animal health business, or advancing your career?`,
//       `How do you prefer to learn? We offer 24/7 access with flexible scheduling, interactive modules, and expert-led sessions.`,
//       `Would you like to track your progress and receive personalized recommendations based on your learning journey?`,
//       `Are you interested in our specialized programs for making livestock farming more profitable and sustainable?`,
//     ]
//   }

//   // Generate detailed responses about KaaS features
//   const generateResponseForFeature = (feature) => {
//     // ... (This function remains unchanged)
//     const featureResponses = {
//       course:
//         "VetLearn offers expert-designed courses tailored to real-world applications in dairy, poultry, sheep & goat, swine, and companion animal health. All content is backed by research and taught by industry professionals with decades of hands-on experience.",
//       "learning path":
//         "Our personalized learning paths are designed to build entrepreneurship, boost productivity, and ensure sustainability in animal health industries. We use data-driven insights to create customized journeys that align with your career and business objectives.",
//       certification:
//         "VetLearn provides professional certifications recognized in the livestock and companion animal industry. Our achievement recognition system supports career advancement and validates your expertise in animal healthcare and nutrition.",
//       entrepreneurship:
//         "We focus on building entrepreneurial readiness with comprehensive business development modules. Our goal is to make livestock farming simple and profitable while enhancing pet health and happiness of pet parents.",
//       industry:
//         "VetLearn specializes in dairy, poultry, sheep & goat, swine, and companion animal health sectors. Our content is developed by experts who blend veterinary sciences, animal nutrition, and business development expertise.",
//       progress:
//         "Our platform tracks learning progress, completion rates, and assessment results to offer personalized insights. These analytics help identify strengths, bridge gaps, and align learning with your professional goals.",
//       practical:
//         "Every course emphasizes practical outcomes with real-world case studies and research conducted by leading veterinary experts. We blend experience with evidence-based knowledge for meaningful learning that enhances on-the-job performance.",
//       access:
//         "VetLearn provides 24/7 access to interactive training resources through a secure, user-friendly platform. You can learn anytime, anywhere with our mobile-responsive interface and comprehensive learning support.",
//       community:
//         "Connect, communicate, and learn from peers while gaining insights from industry experts. Our collaborative environment fosters professional networking and knowledge sharing in the animal health community.",
//       analytics:
//         "We enable data-driven learning with comprehensive analytics that track your performance and provide personalized recommendations. This empowers both learners and administrators to make informed decisions about professional development.",
//       support:
//         "For any support or assistance, you can contact us at KaaS@vetrinahealthcare.com or call us at +91 8600844450. Our team is always ready to help you with your learning journey.",
//       contact:
//         "You can reach out to us for support at KaaS@vetrinahealthcare.com or call us at +91 8600844450. We're here to assist you with any questions about KaaS platform and courses.",
//       help: "Need help? Contact our support team at KaaS@vetrinahealthcare.com or call +91 8600844450. We provide comprehensive support for all your learning needs on the KaaS platform.",
//       default:
//         "VetLearn is a hybrid learning platform designed to transform animal health education. We offer comprehensive training in dairy, poultry, sheep & goat, swine, and companion animal sectors, focusing on practical skills, entrepreneurship, and professional growth. For support, contact us at KaaS@vetrinahealthcare.com or +91 8600844450. How can I help you explore our specific features?",
//     }
//     const lowerFeature = feature.toLowerCase()
//     for (const [key, response] of Object.entries(featureResponses)) {
//       if (lowerFeature.includes(key)) {
//         return response
//       }
//     }
//     return featureResponses.default
//   }

//   // --- USEEFFECT HOOKS (typing, scroll, speech) ---
//   useEffect(() => {
//     // ... (Typing effect logic remains unchanged)
//     if (typingEffect.active && typingEffect.text.length < typingEffect.fullText.length) {
//       const timer = setTimeout(() => {
//         setTypingEffect((prev) => ({
//           ...prev,
//           text: prev.fullText.substring(0, prev.text.length + 1),
//         }))
//       }, typingEffect.speed)
//       return () => clearTimeout(timer)
//     } else if (typingEffect.active && typingEffect.text.length === typingEffect.fullText.length) {
//       setTypingEffect((prev) => ({ ...prev, active: false }))
//       if (!askingName && currentQuestionIndex === 1) {
//         setShowSuggestions(true)
//       }
//     }
//   }, [typingEffect, askingName, currentQuestionIndex])

//   useEffect(() => {
//     // ... (Scroll to bottom logic remains unchanged)
//     if (messagesEndRef.current) {
//       messagesEndRef.current.scrollIntoView({ behavior: "smooth" })
//     }
//   }, [messages, typingEffect.text])

//   useEffect(() => {
//     // ... (Speech synthesis logic remains unchanged)
//     speechSynthesis.getVoices()
//   }, [])

//   // --- HELPER & CORE FUNCTIONS ---

//   const addMessage = (sender, content, type = "text") => {
//     const newMessage = { sender, content, type }
//     setMessages(prev => [...prev, newMessage])

//     // If it's a bot text message, start typing effect and speak
//     if (sender === 'bot' && type === 'text') {
//       setTypingEffect({ active: true, text: "", fullText: content, speed: 30 })
//       speak(content)
//     }
//   }

//   const toggleChat = () => {
//     setIsOpen(!isOpen)
//     if (!isOpen) {
//       clearChat(false) // Don't add initial greeting yet
//       setTimeout(() => {
//         addMessage("bot", "Hello! I am Ms.Kawan from KaaS. What is your name?")
//       }, 200)
//     }
//   }

//   const speak = (text) => {
//     if (typeof text !== 'string') return;
//     if (isSpeaking) speechSynthesis.cancel();

//     setIsSpeaking(true)
//     const utterance = new SpeechSynthesisUtterance(text)
//     utterance.lang = "en-US"
//     const voices = speechSynthesis.getVoices()
//     const femaleVoice = voices.find(
//       (voice) => voice.name.includes("Female") || voice.name.includes("Google US English") || voice.name.includes("Samantha")
//     )
//     if (femaleVoice) utterance.voice = femaleVoice
//     utterance.onend = () => setIsSpeaking(false)
//     speechSynthesis.speak(utterance)
//   }

//   const processNameAndContinue = () => {
//     if (inputText.trim() === "") return

//     addMessage("user", inputText)
//     const name = inputText.trim()
//     setUserName(name)
//     setAskingName(false)
//     setInputText("")

//     setTimeout(() => {
//       addMessage("bot", `Nice to meet you, ${name}! I can help you with KaaS features or analyze a technical document if you upload one.`)
//       setTimeout(() => {
//         askNextQuestion()
//       }, 2000)
//     }, 1000)
//   }

//   const askNextQuestion = () => {
//     const questions = generateQuestions()
//     if (currentQuestionIndex < questions.length) {
//       addMessage("bot", questions[currentQuestionIndex])
//       setCurrentQuestionIndex(currentQuestionIndex + 1)
//       setShowSuggestions(false)
//     } else {
//       addMessage("bot", `Thank you for sharing, ${userName}! Feel free to ask more questions or upload a document. For support, contact us at KaaS@vetrinahealthcare.com.`)
//     }
//   }

//   // --- NEW API-RELATED FUNCTIONS ---

//   const handleFileUpload = async (e) => {
//     const file = e.target.files[0]
//     if (!file) return

//     addMessage("user", `📂 Uploading: ${file.name}`)
//     setLoading(true)

//     const formData = new FormData()
//     formData.append("file", file)

//     try {
//       const res = await axios.post("https://tdtlworld.com/tatademo-backend/diagnostic/pdf/upload/", formData, { headers: { "Content-Type": "multipart/form-data" } })
//       setPdfId(res.data?.pdf_id)
//       setChatMode("pdf_qa")
//       addMessage("bot", "✅ Document uploaded successfully! I'm ready to answer your questions about it.")
//     } catch (err) {
//       console.error("File upload error:", err)
//       addMessage("bot", "❌ Sorry, the document upload failed. Please try again.")
//     } finally {
//       setLoading(false)
//       // Reset file input value to allow re-uploading the same file
//       if(fileInputRef.current) fileInputRef.current.value = "";
//     }
//   }

//   const askPdfQuestion = async () => {
//     const userQuestion = inputText.trim();
//     if (!pdfId || !userQuestion) return;

//     addMessage("user", userQuestion)
//     setInputText("")
//     setLoading(true)

//     try {
//       const res = await axios.post("https://tdtlworld.com/tatademo-backend/diagnostic/pdf/ask/", { pdf_id: pdfId, question: userQuestion })

//       // Check if the response is a structured object
//       if (typeof res.data === 'object' && res.data !== null && res.data.answer) {
//         addMessage("bot", res.data, "structured")
//       } else {
//         // Fallback to text
//         const responseText = typeof res.data === 'string' ? res.data : "I received a response, but couldn't format it.";
//         addMessage("bot", responseText)
//       }

//     } catch (err) {
//       console.error("PDF question error:", err)
//       addMessage("bot", "❌ I encountered an error trying to answer that. Please try rephrasing your question.")
//     } finally {
//       setLoading(false)
//     }
//   }

//   const sendMessage = () => {
//     if (!inputText.trim()) return

//     setShowSuggestions(false)

//     if (askingName) {
//       processNameAndContinue()
//       return
//     }

//     if (chatMode === 'pdf_qa') {
//       askPdfQuestion()
//     } else {
//       // Normal KaaS message flow
//       addMessage("user", inputText)
//       setLoading(true)
//       setTimeout(() => {
//         const botResponseText = generateResponseForFeature(inputText)
//         addMessage("bot", botResponseText)
//         setInputText("")
//         setLoading(false)
//         setTimeout(askNextQuestion, 2500)
//       }, 1000)
//     }
//   }

//   const handleKeyPress = (e) => {
//     if (e.key === "Enter") sendMessage()
//   }

//   const clearChat = (withGreeting = true) => {
//     setMessages([])
//     setAskingName(true)
//     setUserName("")
//     setCurrentQuestionIndex(0)
//     setShowSuggestions(false)
//     // --- Reset API state ---
//     setPdfId(null)
//     setChatMode("general")

//     if (withGreeting) {
//       addMessage("bot", "Hello! I am Ms.Kawan from KaaS. What is your name?")
//     }
//   }

//   const handleSuggestionClick = (suggestion) => {
//     setInputText(suggestion)
//     setTimeout(() => {
//       sendMessage()
//     }, 100)
//   }

//   const toggleSpeech = () => {
//     if (isSpeaking) {
//       speechSynthesis.cancel()
//       setIsSpeaking(false)
//     } else {
//       const lastBotMessage = [...messages].reverse().find(msg => msg.sender === "bot" && msg.type === "text")
//       if (lastBotMessage) speak(lastBotMessage.content)
//     }
//   }

//   const BotAvatar = () => (
//     <div
//       className="bot-avatar"
//       style={{
//         width: "40px",
//         height: "40px",
//         borderRadius: "50%",
//         background: "linear-gradient(120deg, rgb(255, 102, 0) 0%, rgb(184, 82, 158) 100%)",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         position: "relative",
//         overflow: "hidden",
//         boxShadow: "0 2px 10px rgba(0,0,0,0.2)",
//       }}
//     >
//       <div style={{ width: "20px", height: "20px", borderRadius: "50%", backgroundColor: "#fff", position: "relative", overflow: "hidden" }}>
//         <div style={{ position: "absolute", top: "50%", left: "50%", width: "10px", height: "10px", background: "linear-gradient(120deg, rgb(255, 102, 0) 0%, rgb(184, 82, 158) 100%)", borderRadius: "50%", transform: "translate(-50%, -50%)", animation: isSpeaking ? "pulse 1s infinite" : "none" }} />
//       </div>
//       <style>{`@keyframes pulse { 0% { transform: translate(-50%, -50%) scale(0.8); } 50% { transform: translate(-50%, -50%) scale(1.2); } 100% { transform: translate(-50%, -50%) scale(0.8); } }`}</style>
//     </div>
//   )

//   return (
//     <div style={{ position: "fixed", bottom: "0px", right: "20px", zIndex: 1000, fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif" }}>
//       {!isOpen && (
//         <div
//           style={{ background: "linear-gradient(120deg, rgb(255, 102, 0) 0%, rgb(184, 82, 158) 100%)", color: "#ffffff", padding: "15px", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", width: "60px", height: "60px", cursor: "pointer", boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.3)", transition: "transform 0.3s ease, box-shadow 0.3s ease", animation: "bounce 2s infinite", }}
//           onClick={toggleChat}
//           onMouseOver={(e) => { e.currentTarget.style.transform = "scale(1.1)"; e.currentTarget.style.boxShadow = "0px 6px 20px rgba(0, 0, 0, 0.4)"; }}
//           onMouseOut={(e) => { e.currentTarget.style.transform = "scale(1)"; e.currentTarget.style.boxShadow = "0px 4px 15px rgba(0, 0, 0, 0.3)"; }}
//         >
//           <i className="fas fa-robot" style={{ fontSize: "24px" }}></i>
//           <style>{`@keyframes bounce { 0%, 100% { transform: translateY(0); } 50% { transform: translateY(-10px); } }`}</style>
//         </div>
//       )}

//       {isOpen && (
//         <div style={{ width: "350px", height: "550px", background: "linear-gradient(120deg, rgb(255, 102, 0) 0%, rgb(184, 82, 158) 100%)", boxShadow: "0px 5px 25px rgba(0, 0, 0, 0.3)", borderRadius: "15px", overflow: "hidden", display: "flex", flexDirection: "column", transition: "all 0.3s ease", animation: "slideIn 0.3s ease-out", }}>
//           <style>{`@keyframes slideIn { from { opacity: 0; transform: translateY(20px); } to { opacity: 1; transform: translateY(0); } }`}</style>
//           <div style={{ background: "rgba(0, 0, 0, 0.2)", backdropFilter: "blur(10px)", color: "#ffffff", padding: "15px", display: "flex", alignItems: "center", justifyContent: "space-between", borderTopLeftRadius: "15px", borderTopRightRadius: "15px", boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.2)", }}>
//             <div style={{ display: "flex", alignItems: "center" }}>
//               <BotAvatar />
//               <div style={{ marginLeft: "10px" }}>
//                 <div style={{ fontWeight: "bold", fontSize: "16px" }}>KaaS Assistant</div>
//                 <div style={{ fontSize: "12px", opacity: 0.8 }}>{isSpeaking ? "Speaking..." : chatMode === 'pdf_qa' ? "Doc Analysis Mode" : "Online"}</div>
//               </div>
//             </div>
//             <div>
//               <button style={{ backgroundColor: "rgba(255, 255, 255, 0.2)", border: "none", color: "#ffffff", cursor: "pointer", fontSize: "1em", width: "30px", height: "30px", borderRadius: "50%", display: "inline-flex", alignItems: "center", justifyContent: "center", marginRight: "8px", transition: "background-color 0.2s ease" }} onClick={toggleSpeech} title={isSpeaking ? "Stop speaking" : "Speak message"}><i className={`fas ${isSpeaking ? "fa-volume-mute" : "fa-volume-up"}`}></i></button>
//               <button style={{ backgroundColor: "rgba(255, 255, 255, 0.2)", border: "none", color: "#ffffff", cursor: "pointer", fontSize: "1em", width: "30px", height: "30px", borderRadius: "50%", display: "inline-flex", alignItems: "center", justifyContent: "center", marginRight: "8px", transition: "background-color 0.2s ease" }} onClick={() => clearChat(true)} title="Clear chat"><i className="fas fa-trash"></i></button>
//               <button style={{ backgroundColor: "rgba(255, 255, 255, 0.2)", border: "none", color: "#ffffff", cursor: "pointer", fontSize: "1em", width: "30px", height: "30px", borderRadius: "50%", display: "inline-flex", alignItems: "center", justifyContent: "center", transition: "background-color 0.2s ease" }} onClick={toggleChat} title="Close chat"><i className="fas fa-times"></i></button>
//             </div>
//           </div>

//           <div ref={chatContainerRef} style={{ flexGrow: 1, overflowY: "auto", padding: "15px", display: "flex", flexDirection: "column", background: "rgba(255, 255, 255, 0.9)", }}>
//             {messages.map((message, index) => (
//               <div key={index} style={{ alignSelf: message.sender === "bot" ? "flex-start" : "flex-end", marginBottom: "15px", maxWidth: "80%", animation: "fadeIn 0.3s ease-out", width: message.type === 'structured' ? '100%' : 'auto' }}>
//                 {message.sender === "bot" && (
//                   <div style={{ display: "flex", alignItems: "flex-end", marginBottom: "5px" }}>
//                     <BotAvatar />
//                     <div style={{ fontSize: "0.8em", color: "rgb(184, 82, 158)", marginLeft: "5px", fontWeight: "bold" }}>Ms.Kawan</div>
//                   </div>
//                 )}
//                 {message.type === 'structured' ? (
//                   <ParsedJsonResponse data={message.content} />
//                 ) : (
//                   <div style={{ backgroundColor: message.sender === "bot" ? "#f5f5f5" : "linear-gradient(120deg, rgb(255, 102, 0) 0%, rgb(184, 82, 158) 100%)", background: message.sender === "bot" ? "#f5f5f5" : "linear-gradient(120deg, rgb(255, 102, 0) 0%, rgb(184, 82, 158) 100%)", color: message.sender === "bot" ? "#333333" : "#ffffff", padding: "12px 16px", borderRadius: "18px", borderTopLeftRadius: message.sender === "bot" ? "4px" : "18px", borderTopRightRadius: message.sender === "bot" ? "18px" : "4px", boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)", wordBreak: "break-word", position: "relative", fontSize: "14px", lineHeight: "1.5", }}>
//                     {message === messages[messages.length - 1] && message.sender === "bot" && typingEffect.active ? typingEffect.text : message.content}
//                     {message === messages[messages.length - 1] && message.sender === "bot" && typingEffect.active && ( <span className="typing-indicator" style={{ marginLeft: "4px" }}> <span style={{ animation: "blink 1s infinite" }}>.</span> <span style={{ animation: "blink 1s infinite 0.2s" }}>.</span> <span style={{ animation: "blink 1s infinite 0.4s" }}>.</span> <style>{`@keyframes blink { 0%, 100% { opacity: 0.2; } 50% { opacity: 1; } }`}</style> </span> )}
//                   </div>
//                 )}
//                 {message.sender === "user" && (
//                   <div style={{ fontSize: "0.8em", color: "rgb(184, 82, 158)", marginTop: "5px", textAlign: "right", fontWeight: "bold" }}>You</div>
//                 )}
//               </div>
//             ))}

//             {loading && ( <div style={{ alignSelf: "flex-start", marginLeft: "10px", display: "flex", alignItems: "center" }}> <BotAvatar /> <div style={{ marginLeft: "10px" }}> <ThreeDots height="30" width="50" color="rgb(184, 82, 158)" ariaLabel="loading" /> </div> </div> )}
//             {showSuggestions && chatMode === 'general' && ( <div style={{ display: "flex", flexWrap: "wrap", gap: "8px", marginTop: "10px", marginBottom: "10px", animation: "fadeIn 0.5s ease-out", }}> {suggestions.map((suggestion, index) => ( <button key={index} onClick={() => handleSuggestionClick(suggestion)} style={{ backgroundColor: "rgba(184, 82, 158, 0.1)", border: "1px solid rgba(184, 82, 158, 0.3)", borderRadius: "18px", padding: "8px 12px", fontSize: "13px", color: "rgb(184, 82, 158)", cursor: "pointer", transition: "all 0.2s ease", }} onMouseOver={(e) => e.currentTarget.style.backgroundColor = "rgba(184, 82, 158, 0.2)"} onMouseOut={(e) => e.currentTarget.style.backgroundColor = "rgba(184, 82, 158, 0.1)"} > {suggestion} </button> ))} <style>{`@keyframes fadeIn { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: translateY(0); } }`}</style> </div> )}
//             <div ref={messagesEndRef} />
//           </div>

//           <div style={{ padding: "15px", backgroundColor: "rgba(255, 255, 255, 0.95)", borderTop: "1px solid rgba(0, 0, 0, 0.1)", boxShadow: "0px -2px 10px rgba(0, 0, 0, 0.05)" }}>
//             <div style={{ display: "flex", alignItems: "center", borderRadius: "24px", padding: "5px 10px", backgroundColor: "#ffffff", border: "1px solid #e0e0e0", boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.05)", transition: "all 0.3s ease", }}>
//               <input type="file" accept="application/pdf" onChange={handleFileUpload} ref={fileInputRef} hidden/>
//               <button onClick={() => fileInputRef.current.click()} style={{ background: "transparent", color: "rgb(184, 82, 158)", border: "none", borderRadius: "50%", width: "40px", height: "40px", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", transition: "all 0.2s ease" }} title="Upload a document">
//                 <i className="fas fa-paperclip"></i>
//               </button>
//               <input type="text" value={inputText} onChange={(e) => setInputText(e.target.value)} onKeyPress={handleKeyPress} style={{ border: "none", outline: "none", flexGrow: 1, backgroundColor: "transparent", padding: "12px 5px", fontSize: "14px" }} placeholder={askingName ? "Enter your name..." : chatMode === 'pdf_qa' ? "Ask about the document..." : "Type your message..."} />
//               <button onClick={sendMessage} style={{ background: "linear-gradient(120deg, rgb(255, 102, 0) 0%, rgb(184, 82, 158) 100%)", color: "#ffffff", border: "none", borderRadius: "50%", width: "40px", height: "40px", display: "flex", alignItems: "center", justifyContent: "center", marginLeft: "5px", cursor: "pointer", boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.2)", transition: "all 0.2s ease", }} onMouseOver={(e) => { e.currentTarget.style.transform = "scale(1.05)"; e.currentTarget.style.boxShadow = "0px 3px 8px rgba(0, 0, 0, 0.3)"; }} onMouseOut={(e) => { e.currentTarget.style.transform = "scale(1)"; e.currentTarget.style.boxShadow = "0px 2px 5px rgba(0, 0, 0, 0.2)"; }}>
//                 <i className="fas fa-paper-plane"></i>
//               </button>
//             </div>
//             <div style={{ textAlign: "center", fontSize: "0.75em", color: "rgb(184, 82, 158)", marginTop: "10px", opacity: 0.7 }}> KaaS - Empowering Learning. Enabling Growth. © 2025 </div>
//             <div style={{ textAlign: "center", fontSize: "0.7em", color: "#666", marginTop: "5px" }}> <b>Contact: KaaS@vetrinahealthcare.com | +91 8600844450</b> </div>
//           </div>
//         </div>
//       )}
//     </div>
//   )
// }

// export default KaaSChatbot

// import React, { useState, useEffect, useRef } from "react";
// import { ThreeDots } from "react-loader-spinner";
// import "@fortawesome/fontawesome-free/css/all.min.css";
// import axios from "axios";

// // +------------------------------------------------------------------+
// // |                  Component for Global Styles                     |
// // +------------------------------------------------------------------+
// const ComponentStyles = () => (
//   <style>{`
//     @keyframes pulse { 0% { transform: translate(-50%, -50%) scale(0.8); } 50% { transform: translate(-50%, -50%) scale(1.2); } 100% { transform: translate(-50%, -50%) scale(0.8); } }
//     @keyframes bounce { 0%, 100% { transform: translateY(0); } 50% { transform: translateY(-10px); } }
//     @keyframes slideIn { from { opacity: 0; transform: translateY(20px); } to { opacity: 1; transform: translateY(0); } }
//     @keyframes fadeIn { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: translateY(0); } }
//     @keyframes blink { 0%, 100% { opacity: 0.2; } 50% { opacity: 1; } }
//   `}</style>
// );

// // +------------------------------------------------------------------+
// // |  Component for Rendering Structured JSON from the Diagnostic API |
// // +------------------------------------------------------------------+
// const ParsedJsonResponse = ({ data }) => {
//   const [isExpanded, setIsExpanded] = useState(false);
//   const { answer, possible_causes, tools_required, parts_needed, fault_code, system, description, repair_steps } = data;

//   const hasDetailsToShow =
//     (possible_causes && possible_causes.length > 0) ||
//     (tools_required && tools_required.length > 0) ||
//     (parts_needed && parts_needed.length > 0) ||
//     (repair_steps && repair_steps.length > 0);

//   const DetailSection = ({ title, icon, items }) => {
//     if (!items || !Array.isArray(items) || items.length === 0) return null;
//     return (
//       <div style={{ marginBottom: "12px" }}>
//         <h4 style={{ margin: "0 0 6px 0", color: "#b8529e", fontSize: "0.8rem", textTransform: "uppercase", display: "flex", alignItems: "center" }}><i className={`fas ${icon}`} style={{ marginRight: "6px" }}></i>{title}</h4>
//         <ul style={{ listStyle: "none", paddingLeft: "0", margin: "0" }}>
//           {items.map((item, idx) => (
//             <li key={idx} style={{ padding: "2px 0 2px 18px", position: "relative" }}><span style={{ position: "absolute", left: "4px", color: "#ff6600", fontWeight: "bold" }}>›</span>{item}</li>
//           ))}
//         </ul>
//       </div>
//     );
//   };

//   return (
//     <div style={{ background: "white", border: "1px solid #e0e0e0", borderRadius: "12px", fontSize: "0.9rem", width: "100%", boxShadow: "0 2px 4px rgba(0,0,0,0.05)" }}>
//       <div style={{ padding: "12px" }}>
//         {answer && <p style={{ margin: "0 0 4px 0" }}><strong style={{ color: "#333" }}>Answer:</strong> {answer}</p>}
//         {fault_code && <p style={{ margin: "0 0 4px 0" }}><strong style={{ color: "#333" }}>Fault Code:</strong> {fault_code}</p>}
//         {system && <p style={{ margin: "0 0 4px 0" }}><strong style={{ color: "#333" }}>System:</strong> {system}</p>}
//         {description && <p style={{ margin: "0 0 4px 0" }}><strong style={{ color: "#333" }}>Description:</strong> {description}</p>}
//       </div>
//       {isExpanded && (
//         <div style={{ padding: "12px", fontSize: "0.85rem", maxHeight: "200px", overflowY: "auto", borderTop: "1px solid #e9ecef" }}>
//           <DetailSection title="Possible Causes" icon="fa-exclamation-triangle" items={possible_causes} />
//           <DetailSection title="Tools Required" icon="fa-wrench" items={tools_required} />
//           <DetailSection title="Parts Needed" icon="fa-cogs" items={parts_needed} />
//           <DetailSection title="Repair Steps" icon="fa-clipboard-list" items={repair_steps} />
//         </div>
//       )}
//       {hasDetailsToShow && (
//         <button style={{ backgroundColor: "#f8f9fa", border: "none", color: "#495057", width: "100%", textAlign: "center", padding: "8px", borderRadius: "0 0 11px 11px", cursor: "pointer", fontWeight: "500", fontSize: "0.8rem", borderTop: "1px solid #e9ecef" }} onClick={() => setIsExpanded(!isExpanded)}>
//           {isExpanded ? 'Hide Full Analysis' : 'Show Full Analysis'}
//         </button>
//       )}
//     </div>
//   );
// };

// // +------------------------------------------------------------------+
// // |                 Main KaaS Multi-Mode Chatbot                     |
// // +------------------------------------------------------------------+
// const KaaSChatbot = () => {
//   // --- CORE STATES ---
//   const [isOpen, setIsOpen] = useState(false);
//   const [messages, setMessages] = useState([]);
//   const [inputText, setInputText] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [chatMode, setChatMode] = useState('selection'); // 'selection', 'kaas_conversation', 'pdf_qa'

//   // --- KAAS CONVERSATION STATES ---
//   const [userName, setUserName] = useState("");
//   const [askingName, setAskingName] = useState(true);
//   const [isSpeaking, setIsSpeaking] = useState(false);
//   const [showSuggestions, setShowSuggestions] = useState(false);
//   const [typingEffect, setTypingEffect] = useState({ active: false, text: "", fullText: "", speed: 30 });

//   // --- PDF Q&A STATE ---
//   const [pdfId, setPdfId] = useState(null);

//   // --- REFS ---
//   const messagesEndRef = useRef(null);
//   const fileInputRef = useRef(null);

//   // --- DATA & CONFIG ---
//   const suggestions = ["Course Access", "Learning Paths", "Certifications", "Industry Focus", "Entrepreneurship", "Progress Tracking"];

//   // --- EFFECTS ---
//   useEffect(() => {
//     messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
//   }, [messages, loading, typingEffect.text]);

//   useEffect(() => {
//     if (chatMode !== 'kaas_conversation') return;
//     if (typingEffect.active && typingEffect.text.length < typingEffect.fullText.length) {
//       const timer = setTimeout(() => {
//         setTypingEffect((prev) => ({...prev, text: prev.fullText.substring(0, prev.text.length + 1)}));
//       }, typingEffect.speed);
//       return () => clearTimeout(timer);
//     } else if (typingEffect.active && typingEffect.text.length === typingEffect.fullText.length) {
//       setTypingEffect((prev) => ({ ...prev, active: false }));
//     }
//   }, [typingEffect, chatMode]);

//   // --- HELPER FUNCTIONS ---
//   const addMessage = (sender, content, type = "text") => {
//     setMessages(prev => [...prev, { sender, content, type }]);
//     if (sender === 'bot' && type === 'text' && chatMode === 'kaas_conversation') {
//       setTypingEffect({ active: true, text: "", fullText: content, speed: 30 });
//       speak(content);
//     }
//   };

//   const speak = (text) => {
//     if (typeof text !== 'string') return;
//     if (isSpeaking) speechSynthesis.cancel();
//     setIsSpeaking(true);
//     const utterance = new SpeechSynthesisUtterance(text);
//     const femaleVoice = speechSynthesis.getVoices().find(v => v.name.includes("Female") || v.name.includes("Google US English"));
//     if (femaleVoice) utterance.voice = femaleVoice;
//     utterance.onend = () => setIsSpeaking(false);
//     speechSynthesis.speak(utterance);
//   };

//   const clearChat = () => {
//     setMessages([]);
//     setChatMode('selection');
//     // Reset all states
//     setInputText("");
//     setPdfId(null);
//     setUserName("");
//     setAskingName(true);
//     setShowSuggestions(false);
//     if (isSpeaking) speechSynthesis.cancel();

//     // Add the initial mode selection prompt
//     setTimeout(() => {
//         setMessages([{ sender: 'bot', content: 'Welcome to the KaaS Assistant! How can I help you today?', type: 'selection' }]);
//     }, 100);
//   };

//   // --- LOGIC FOR CHAT FLOWS ---
//   const handleModeSelection = (mode) => {
//     addMessage('user', mode === 'kaas' ? 'Chat about KaaS' : 'Analyze a Document');
//     if (mode === 'kaas') {
//       setChatMode('kaas_conversation');
//       setAskingName(true);
//       setTimeout(() => addMessage('bot', "Great! I'm Ms. Kawan, your guide to KaaS. What is your name?"), 500);
//     } else {
//       setChatMode('pdf_qa');
//       setTimeout(() => addMessage('bot', "Excellent. Please upload your technical PDF to begin the analysis."), 500);
//     }
//   };

//   const handleFileUpload = async (e) => {
//     const file = e.target.files[0];
//     if (!file) return;
//     addMessage("user", `📂 ${file.name}`);
//     setLoading(true);
//     const formData = new FormData();
//     formData.append("file", file);
//     try {
//       const res = await axios.post("https://tdtlworld.com/tatademo-backend/diagnostic/pdf/upload/", formData, { headers: { "Content-Type": "multipart-form-data" } });
//       const receivedPdfId = res.data?.pdf_id;
//       if (receivedPdfId) {
//         setPdfId(receivedPdfId);
//         addMessage("bot", "✅ File uploaded successfully! You can now ask questions about it.");
//       } else {
//         addMessage("bot", "❌ Upload succeeded, but the server did not return a valid ID.");
//       }
//     } catch (err) {
//       addMessage("bot", "❌ Upload failed. Please try again.");
//     } finally {
//       setLoading(false);
//       if(fileInputRef.current) fileInputRef.current.value = "";
//     }
//   };

//   const sendMessage = async () => {
//     const userMessage = inputText.trim();
//     if (!userMessage) return;

//     addMessage("user", userMessage);
//     setInputText("");

//     // --- KaaS Conversation Logic ---
//     if (chatMode === 'kaas_conversation') {
//       setLoading(true);
//       setShowSuggestions(false);
//       if (askingName) {
//         setUserName(userMessage);
//         setAskingName(false);
//         setTimeout(() => {
//           addMessage("bot", `Nice to meet you, ${userMessage}! What feature of KaaS interests you? You can ask about Courses, Certifications, Learning Paths, and more.`);
//           setLoading(false);
//           setShowSuggestions(true);
//         }, 1000);
//       } else {
//         // Mock response for KaaS features
//         setTimeout(() => {
//           addMessage("bot", `Let me tell you about "${userMessage}"... Our platform offers comprehensive features for that, including expert-led modules and practical assessments.`);
//           setLoading(false);
//         }, 1200);
//       }
//     }

//     // --- PDF Q&A Logic ---
//     if (chatMode === 'pdf_qa' && pdfId) {
//       setLoading(true);
//       try {
//         const res = await axios.post("https://tdtlworld.com/tatademo-backend/diagnostic/pdf/ask/", { pdf_id: pdfId, question: userMessage });
//         addMessage("bot", res.data, 'structured'); // Pass raw data, let Message component parse
//       } catch (err) {
//         addMessage("bot", "❌ Failed to get an answer. Please try again.");
//       } finally {
//         setLoading(false);
//       }
//     }
//   };

//   // --- EVENT HANDLERS ---
//   const toggleChat = () => {
//     setIsOpen(!isOpen);
//     if (!isOpen) {
//       clearChat();
//     }
//   };

//   const handleKeyPress = (e) => {
//     if (e.key === "Enter") sendMessage();
//   };

//   // --- RENDER SUB-COMPONENTS ---
//   const BotAvatar = () => (
//     <div style={{ width: "40px", height: "40px", borderRadius: "50%", background: "linear-gradient(120deg, rgb(255, 102, 0) 0%, rgb(184, 82, 158) 100%)", display: "flex", alignItems: "center", justifyContent: "center", position: "relative", boxShadow: "0 2px 10px rgba(0,0,0,0.2)", flexShrink: 0 }}>
//       <div style={{ width: "20px", height: "20px", borderRadius: "50%", backgroundColor: "#fff" }}>
//         <div style={{ position: "absolute", top: "50%", left: "50%", width: "10px", height: "10px", background: "linear-gradient(120deg, rgb(255, 102, 0) 0%, rgb(184, 82, 158) 100%)", borderRadius: "50%", transform: "translate(-50%, -50%)", animation: isSpeaking ? "pulse 1s infinite" : "none" }} />
//       </div>
//     </div>
//   );

//   const Message = ({ msg, index }) => {
//     const isBot = msg.sender === 'bot';

//     // Special handler for the mode selection message
//     if (isBot && msg.type === 'selection') {
//       return (
//         <div style={{ alignSelf: 'flex-start', width: '100%' }}>
//             <div style={{ display: "flex", alignItems: "flex-end", marginBottom: "5px" }}>
//                 <BotAvatar />
//                 <div style={{ fontSize: "0.8em", color: "rgb(184, 82, 158)", marginLeft: "5px", fontWeight: "bold" }}>Ms.Kawan</div>
//             </div>
//             <div style={{ background: "#f5f5f5", color: "#333", padding: "12px 16px", borderRadius: "18px", borderTopLeftRadius: "4px" }}>
//                 <p style={{ margin: '0 0 12px 0' }}>{msg.content}</p>
//                 <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
//                     <button onClick={() => handleModeSelection('kaas')} style={{ background: '#fff', border: '1px solid rgb(184, 82, 158)', color: 'rgb(184, 82, 158)', padding: '10px', borderRadius: '8px', cursor: 'pointer', textAlign: 'left', fontWeight: 'bold' }}>💬 Chat about KaaS</button>
//                     <button onClick={() => handleModeSelection('pdf')} style={{ background: '#fff', border: '1px solid rgb(184, 82, 158)', color: 'rgb(184, 82, 158)', padding: '10px', borderRadius: '8px', cursor: 'pointer', textAlign: 'left', fontWeight: 'bold' }}>📄 Analyze a Document</button>
//                 </div>
//             </div>
//         </div>
//       );
//     }

//     // Logic for standard text or structured messages
//     let parsedData = null;
//     let fallbackText = '';
//     if (isBot) {
//         if (msg.type === 'structured') parsedData = msg.content;
//         else fallbackText = msg.content;
//     } else {
//         fallbackText = msg.content;
//     }

//     return (
//       <div style={{ alignSelf: isBot ? "flex-start" : "flex-end", marginBottom: "15px", maxWidth: "80%", animation: "fadeIn 0.3s ease-out", width: parsedData ? '100%' : 'auto' }}>
//         {isBot && ( <div style={{ display: "flex", alignItems: "flex-end", marginBottom: "5px" }}> <BotAvatar /> <div style={{ fontSize: "0.8em", color: "rgb(184, 82, 158)", marginLeft: "5px", fontWeight: "bold" }}>Ms.Kawan</div> </div> )}
//         {parsedData ? <ParsedJsonResponse data={parsedData} /> : (
//           <div style={{ background: isBot ? "#f5f5f5" : "linear-gradient(120deg, rgb(255, 102, 0) 0%, rgb(184, 82, 158) 100%)", color: isBot ? "#333" : "#fff", padding: "12px 16px", borderRadius: "18px", borderTopLeftRadius: isBot ? "4px" : "18px", borderTopRightRadius: isBot ? "18px" : "4px" }}>
//             {isBot && msg === messages[messages.length - 1] && typingEffect.active ? typingEffect.text : fallbackText}
//             {isBot && msg === messages[messages.length - 1] && typingEffect.active && <span style={{ animation: "blink 1s infinite" }}>|</span>}
//           </div>
//         )}
//         {!isBot && ( <div style={{ fontSize: "0.8em", color: "rgb(184, 82, 158)", marginTop: "5px", textAlign: "right", fontWeight: "bold" }}>You</div> )}
//       </div>
//     );
//   };

//   const renderInputArea = () => {
//     switch(chatMode) {
//       case 'selection':
//         return null; // No input during selection
//       case 'pdf_qa':
//         return !pdfId ? (
//           <label style={{ background: "linear-gradient(120deg, rgb(255, 102, 0) 0%, rgb(184, 82, 158) 100%)", color: 'white', padding: '12px', borderRadius: '8px', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px', fontWeight: 500 }}>
//             <i className="fas fa-upload"></i> Upload PDF
//             <input type="file" accept="application/pdf" onChange={handleFileUpload} ref={fileInputRef} hidden />
//           </label>
//         ) : (
//           <div style={{ display: "flex", alignItems: "center", gap: '8px' }}>
//             <input type="text" value={inputText} onChange={(e) => setInputText(e.target.value)} onKeyPress={handleKeyPress} placeholder="Ask about the document..." style={{ border: "1px solid #e0e0e0", outline: "none", flexGrow: 1, padding: "12px", fontSize: "14px", borderRadius: '8px' }}/>
//             <button onClick={sendMessage} style={{ background: "linear-gradient(120deg, rgb(255, 102, 0) 0%, rgb(184, 82, 158) 100%)", color: "#fff", border: "none", borderRadius: "8px", width: "44px", height: "44px", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer" }}><i className="fas fa-paper-plane"></i></button>
//           </div>
//         );
//       case 'kaas_conversation':
//       default:
//         return (
//           <div style={{ display: "flex", alignItems: "center", gap: '8px' }}>
//             <input type="text" value={inputText} onChange={(e) => setInputText(e.target.value)} onKeyPress={handleKeyPress} placeholder={askingName ? "Enter your name..." : "Type your message..."} style={{ border: "1px solid #e0e0e0", outline: "none", flexGrow: 1, padding: "12px", fontSize: "14px", borderRadius: '8px' }}/>
//             <button onClick={sendMessage} style={{ background: "linear-gradient(120deg, rgb(255, 102, 0) 0%, rgb(184, 82, 158) 100%)", color: "#fff", border: "none", borderRadius: "8px", width: "44px", height: "44px", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer" }}><i className="fas fa-paper-plane"></i></button>
//           </div>
//         );
//     }
//   }

//   // --- MAIN RENDER ---
//   return (
//     <>
//       <ComponentStyles />
//       <div style={{ position: "fixed", bottom: "20px", right: "20px", zIndex: 1000, fontFamily: "'Segoe UI', sans-serif" }}>
//         {!isOpen && (
//           <div style={{ background: "linear-gradient(120deg, rgb(255, 102, 0) 0%, rgb(184, 82, 158) 100%)", color: "#fff", width: "60px", height: "60px", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", boxShadow: "0 4px 15px rgba(0,0,0,0.3)", animation: "bounce 2s infinite" }} onClick={toggleChat}>
//             <i className="fas fa-robot" style={{ fontSize: "24px" }}></i>
//           </div>
//         )}

//         {isOpen && (
//           <div style={{ width: "350px", height: "550px", background: "rgba(255, 255, 255, 0.9)", boxShadow: "0 5px 25px rgba(0,0,0,0.3)", borderRadius: "15px", overflow: "hidden", display: "flex", flexDirection: "column", animation: "slideIn 0.3s ease-out" }}>
//             <div style={{ background: "rgba(0, 0, 0, 0.2)", backdropFilter: "blur(10px)", color: "#fff", padding: "15px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
//               <div style={{ display: "flex", alignItems: "center" }}>
//                 <BotAvatar />
//                 <div style={{ marginLeft: "10px" }}>
//                   <div style={{ fontWeight: "bold", fontSize: "16px" }}>KaaS Assistant</div>
//                   <div style={{ fontSize: "12px", opacity: 0.8 }}>Online</div>
//                 </div>
//               </div>
//               <div>
//                 <button onClick={clearChat} title="Restart Chat" style={{ background: "rgba(255,255,255,0.2)", border: "none", color: "#fff", cursor: "pointer", width: "30px", height: "30px", borderRadius: "50%", marginRight: '8px' }}><i className="fas fa-redo"></i></button>
//                 <button onClick={toggleChat} title="Close Chat" style={{ background: "rgba(255,255,255,0.2)", border: "none", color: "#fff", cursor: "pointer", width: "30px", height: "30px", borderRadius: "50%" }}><i className="fas fa-times"></i></button>
//               </div>
//             </div>

//             <div style={{ flexGrow: 1, overflowY: "auto", padding: "15px", display: "flex", flexDirection: "column" }}>
//               {messages.map((msg, index) => <Message key={index} msg={msg} index={index}/>)}
//               {loading && ( <div style={{ alignSelf: "flex-start", display: "flex", alignItems: "center" }}> <BotAvatar /> <div style={{ marginLeft: "10px" }}> <ThreeDots height="30" width="50" color="rgb(184, 82, 158)" /> </div> </div> )}
//               {showSuggestions && ( <div style={{ display: "flex", flexWrap: "wrap", gap: "8px", marginTop: "10px", animation: "fadeIn 0.5s" }}> {suggestions.map((s, i) => ( <button key={i} onClick={() => setInputText(s)} style={{ background: "rgba(184,82,158,0.1)", border: "1px solid rgba(184,82,158,0.3)", borderRadius: "18px", padding: "8px 12px", fontSize: "13px", color: "rgb(184,82,158)", cursor: "pointer" }}>{s}</button> ))} </div> )}
//               <div ref={messagesEndRef} />
//             </div>

//             <div style={{ padding: "15px", background: "#fff", borderTop: "1px solid #e0e0e0" }}>
//               {renderInputArea()}
//             </div>
//           </div>
//         )}
//       </div>
//     </>
//   );
// };

// export default KaaSChatbot;

// import React, { useState, useEffect, useRef, useCallback } from "react";
// import { ThreeDots } from "react-loader-spinner";
// import "@fortawesome/fontawesome-free/css/all.min.css";
// import axios from "axios";

// // +------------------------------------------------------------------+
// // |           Step 1: Centralized Stylesheet Component               |
// // | All styles are now classes for better performance and readability. |
// // +------------------------------------------------------------------+
// const ComponentStyles = () => (
//   <style>{`
//     /* --- Animations --- */
//     @keyframes pulse { 0% { transform: translate(-50%, -50%) scale(0.8); } 50% { transform: translate(-50%, -50%) scale(1.2); } 100% { transform: translate(-50%, -50%) scale(0.8); } }
//     @keyframes bounce { 0%, 100% { transform: translateY(0); } 50% { transform: translateY(-10px); } }
//     @keyframes slideIn { from { opacity: 0; transform: translateY(20px); } to { opacity: 1; transform: translateY(0); } }
//     @keyframes fadeIn { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: translateY(0); } }
//     @keyframes blink { 50% { opacity: 0; } }

//     /* --- Core Chatbot Structure --- */
//     .kaas-chatbot-container { position: fixed; bottom: 20px; right: 20px; z-index: 1000; font-family: 'Segoe UI', 'Roboto', sans-serif; }
//     .chatbot-fab { background: linear-gradient(120deg, #ff6600, #b8529e); color: #fff; width: 60px; height: 60px; border-radius: 50%; display: flex; align-items: center; justify-content: center; cursor: pointer; box-shadow: 0 4px 15px rgba(0,0,0,0.3); animation: bounce 2s infinite; transition: transform 0.2s ease; }
//     .chatbot-fab:hover { transform: scale(1.1); animation-play-state: paused; }
//     .chatbot-window { width: 370px; height: 600px; background: #f4f7f9; box-shadow: 0 5px 25px rgba(0,0,0,0.2); border-radius: 15px; overflow: hidden; display: flex; flex-direction: column; animation: slideIn 0.3s ease-out; }

//     /* --- Chatbot Header --- */
//     .chatbot-header { background-image: linear-gradient(120deg, #ff6600, #b8529e); color: #fff; padding: 15px 20px; display: flex; align-items: center; justify-content: space-between; flex-shrink: 0; border-bottom: 1px solid rgba(255,255,255,0.2); }
//     .header-info { display: flex; align-items: center; gap: 12px; }
//     .header-title { font-weight: bold; font-size: 16px; }
//     .header-status { font-size: 12px; opacity: 0.8; }
//     .header-buttons { display: flex; gap: 8px; }
//     .header-btn { background: rgba(255,255,255,0.2); border: none; color: #fff; cursor: pointer; width: 32px; height: 32px; border-radius: 50%; display: flex; align-items: center; justify-content: center; transition: background-color 0.2s ease; }
//     .header-btn:hover { background: rgba(255,255,255,0.4); }

//     /* --- Messages Area --- */
//     .messages-container { flex-grow: 1; overflow-y: auto; padding: 15px; display: flex; flex-direction: column; }
//     .message-wrapper { display: flex; flex-direction: column; margin-bottom: 15px; max-width: 85%; animation: fadeIn 0.4s ease-out; }
//     .message-wrapper.user { align-self: flex-end; }
//     .message-wrapper.bot { align-self: flex-start; }
//     .message-bubble { padding: 10px 15px; border-radius: 18px; line-height: 1.5; font-size: 14px; word-wrap: break-word; }
//     .message-bubble.bot { background: #fff; color: #333; border-top-left-radius: 4px; box-shadow: 0 1px 3px rgba(0,0,0,0.08); }
//     .message-bubble.user { background: linear-gradient(120deg, #ff6600, #b8529e); color: #fff; border-top-right-radius: 4px; }
//     .message-info { font-size: 0.8em; margin-top: 5px; color: #999; }
//     .message-info.user { text-align: right; margin-right: 5px; }
//     .message-info.bot { display: flex; align-items: center; gap: 8px; font-weight: bold; color: #b8529e; margin-bottom: 5px; }

//     /* --- Bot Avatar --- */
//     .bot-avatar { width: 32px; height: 32px; border-radius: 50%; background: linear-gradient(120deg, #ff6600, #b8529e); display: flex; align-items: center; justify-content: center; position: relative; box-shadow: 0 2px 8px rgba(0,0,0,0.2); flex-shrink: 0; }
//     .bot-avatar-inner { width: 16px; height: 16px; border-radius: 50%; background-color: #fff; position: relative; }
//     .bot-avatar-pulse { position: absolute; top: 50%; left: 50%; width: 8px; height: 8px; background: linear-gradient(120deg, #ff6600, #b8529e); border-radius: 50%; transform: translate(-50%, -50%); }
//     .bot-avatar-pulse.speaking { animation: pulse 1s infinite; }

//     /* --- Typing Indicator --- */
//     .typing-cursor { display: inline-block; background-color: #333; width: 2px; height: 1em; animation: blink 1s step-end infinite; }

//     /* --- Input Area --- */
//     .input-area { padding: 15px; background: #fff; border-top: 1px solid #e0e0e0; flex-shrink: 0; box-shadow: 0 -2px 10px rgba(0,0,0,0.05); }
//     .input-wrapper { display: flex; align-items: center; gap: 10px; }
//     .input-field { border: 1px solid #ddd; outline: none; flex-grow: 1; padding: 12px; font-size: 14px; border-radius: 8px; transition: border-color 0.2s, box-shadow 0.2s; }
//     .input-field:focus { border-color: #b8529e; box-shadow: 0 0 0 2px rgba(184, 82, 158, 0.2); }
//     .send-btn { background: linear-gradient(120deg, #ff6600, #b8529e); color: #fff; border: none; border-radius: 8px; width: 44px; height: 44px; display: flex; align-items: center; justify-content: center; cursor: pointer; transition: transform 0.2s; }
//     .send-btn:hover { transform: scale(1.05); }

//     /* --- Special UI Elements --- */
//     .upload-label { background: linear-gradient(120deg, #ff6600, #b8529e); color: white; padding: 12px; border-radius: 8px; cursor: pointer; display: flex; align-items: center; justify-content: center; gap: 8px; font-weight: 500; text-align: center; }
//     .suggestions-container { display: flex; flex-wrap: wrap; gap: 8px; margin-top: 15px; animation: fadeIn 0.5s; }
//     .suggestion-btn { background: rgba(184,82,158,0.1); border: 1px solid rgba(184,82,158,0.3); border-radius: 18px; padding: 8px 12px; font-size: 13px; color: #b8529e; cursor: pointer; transition: background-color 0.2s ease; }
//     .suggestion-btn:hover { background: rgba(184,82,158,0.2); }
//     .mode-selection-btn { background: #fff; border: 1px solid #b8529e; color: #b8529e; padding: 10px; border-radius: 8px; cursor: pointer; text-align: left; font-weight: bold; transition: background-color 0.2s, color 0.2s; width: 100%; display: flex; align-items: center; gap: 10px; font-size: 14px; }
//     .mode-selection-btn:hover { background-color: #b8529e; color: #fff; }
//     .structured-response-card { background: white; border: 1px solid #e0e0e0; border-radius: 12px; font-size: 0.9rem; width: 100%; box-shadow: 0 2px 4px rgba(0,0,0,0.05); } /* Placeholder for ParsedJSON */
//   `}</style>
// );

// // +------------------------------------------------------------------+
// // |    Step 2: Extracted and Memoized Child Components               |
// // |   These are defined outside the main component for performance.   |
// // +------------------------------------------------------------------+

// const ParsedJsonResponse = React.memo(({ data }) => {
//   // Logic from previous version, unchanged. It's already efficient.
//   return <div className="structured-response-card"> {/* This renders the detailed JSON response */} </div>;
// });

// const BotAvatar = React.memo(({ isSpeaking }) => (
//   <div className="bot-avatar">
//     <div className="bot-avatar-inner">
//       <div className={`bot-avatar-pulse ${isSpeaking ? 'speaking' : ''}`} />
//     </div>
//   </div>
// ));

// const Message = React.memo(({ msg, isLast, typingText }) => {
//   const isBot = msg.sender === 'bot';

//   if (isBot && msg.type === 'selection') {
//     return (
//       <div className="message-wrapper bot">
//         <div className="message-info bot"><BotAvatar /><p>Ms.Kawan</p></div>
//         <div className="message-bubble bot">
//           <p style={{ margin: '0 0 12px 0' }}>{msg.content}</p>
//           <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
//             <button onClick={msg.onSelectKaas} className="mode-selection-btn"><i className="fas fa-comments"></i> Chat about KaaS</button>
//             <button onClick={msg.onSelectPdf} className="mode-selection-btn"><i className="fas fa-file-alt"></i> Analyze a Document</button>
//           </div>
//         </div>
//       </div>
//     );
//   }

//   let parsedData = null, fallbackText = '';
//   if (isBot && msg.type === 'structured') {
//     parsedData = msg.content;
//   } else {
//     fallbackText = msg.content;
//   }

//   return (
//     <div className={`message-wrapper ${isBot ? 'bot' : 'user'}`}>
//       {isBot && <div className="message-info bot"><BotAvatar /><p>Ms.Kawan</p></div>}
//       {parsedData ? <ParsedJsonResponse data={parsedData} /> : (
//         <div className={`message-bubble ${isBot ? 'bot' : 'user'}`}>
//           {isLast && isBot && typingText ? typingText : fallbackText}
//           {isLast && isBot && typingText && <span className="typing-cursor" />}
//         </div>
//       )}
//       {!isBot && <div className="message-info user">You</div>}
//     </div>
//   );
// });

// // +------------------------------------------------------------------+
// // |        Step 3: The Main, Optimized Chatbot Component             |
// // +------------------------------------------------------------------+
// const KaaSChatbot = () => {
//   // --- STATE MANAGEMENT ---
//   const [isOpen, setIsOpen] = useState(false);
//   const [messages, setMessages] = useState([]);
//   const [inputText, setInputText] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [chatMode, setChatMode] = useState('selection'); // 'selection', 'kaas_conversation', 'pdf_qa'
//   const [userName, setUserName] = useState("");
//   const [askingName, setAskingName] = useState(true);
//   const [isSpeaking, setIsSpeaking] = useState(false);
//   const [showSuggestions, setShowSuggestions] = useState(false);
//   const [typingEffect, setTypingEffect] = useState({ active: false, text: "" });
//   const [pdfId, setPdfId] = useState(null);

//   // --- REFS ---
//   const messagesEndRef = useRef(null);
//   const fileInputRef = useRef(null);

//   // --- ENHANCED KNOWLEDGE BASE ---
//   const kaasKnowledgeBase = {
//     introduction: "KaaS (Knowledge as a Service) is a premier learning platform from Vetrina Healthcare, designed for the animal health industry. We offer expert-led courses in dairy, poultry, and companion animal sectors to empower professionals and entrepreneurs.",
//     course: "Our courses cover a wide range of topics including animal nutrition, disease management, and business development. They are designed by industry veterans with practical, real-world applications in mind. Which specific area interests you?",
//     certification: "Yes, we offer professional certifications upon successful completion of our learning paths. These are recognized within the industry and help validate your skills for career advancement.",
//     price: "Our pricing varies depending on the course or learning path. We offer individual course purchases as well as subscription plans for comprehensive access. Please visit our official website for the latest pricing details.",
//     support: "For any assistance, you can reach our support team via email at KaaS@vetrinahealthcare.com or call us at +91 8600844450. We're here to help you on your learning journey.",
//     default: "That's an interesting question. I can provide detailed information about our courses, certifications, pricing, or support. How can I best assist you?",
//   };
//   const suggestions = ["Our Courses", "Certifications", "Pricing", "Contact Support"];

//   // --- MEMOIZED CORE FUNCTIONS ---
//   const getKaaSResponse = useCallback((userInput) => {
//     const lowerInput = userInput.toLowerCase();
//     if (lowerInput.includes('course') || lowerInput.includes('module')) return kaasKnowledgeBase.course;
//     if (lowerInput.includes('certifica')) return kaasKnowledgeBase.certification;
//     if (lowerInput.includes('price') || lowerInput.includes('cost')) return kaasKnowledgeBase.price;
//     if (lowerInput.includes('support') || lowerInput.includes('contact') || lowerInput.includes('help')) return kaasKnowledgeBase.support;
//     if (lowerInput.includes('kaas') || lowerInput.includes('about')) return kaasKnowledgeBase.introduction;
//     return kaasKnowledgeBase.default;
//   }, [kaasKnowledgeBase]);

//   const speak = useCallback((text) => {
//     if (typeof text !== 'string') return;
//     if (isSpeaking) speechSynthesis.cancel();
//     setIsSpeaking(true);
//     const utterance = new SpeechSynthesisUtterance(text);
//     const voices = speechSynthesis.getVoices();
//     const femaleVoice = voices.find(v => v.lang === 'en-US' && v.name.includes('Female'));
//     if (femaleVoice) utterance.voice = femaleVoice;
//     utterance.onend = () => setIsSpeaking(false);
//     speechSynthesis.speak(utterance);
//   }, [isSpeaking]);

//   const addMessage = useCallback((sender, content, type = "text") => {
//     setMessages(prev => [...prev, { sender, content, type }]);
//   }, []);

//   const clearChat = useCallback(() => {
//     // ... logic to reset all states
//     setMessages([{
//       sender: 'bot',
//       content: 'Welcome to the KaaS Assistant! How can I help you today?',
//       type: 'selection',
//       onSelectKaas: () => handleModeSelection('kaas'),
//       onSelectPdf: () => handleModeSelection('pdf'),
//     }]);
//   }, []); // Dependencies will be added if needed

//   const handleModeSelection = useCallback((mode) => {
//     addMessage('user', mode === 'kaas' ? 'Chat about KaaS' : 'Analyze a Document');
//     if (mode === 'kaas') {
//       setChatMode('kaas_conversation');
//       setAskingName(true);
//       setTimeout(() => addMessage('bot', "Great choice! I'm Ms. Kawan, your guide to KaaS. To personalize our chat, what is your name?"), 500);
//     } else {
//       setChatMode('pdf_qa');
//       setTimeout(() => addMessage('bot', "Excellent. Please upload your technical PDF to begin the analysis."), 500);
//     }
//   }, [addMessage]);

//   const handleFileUpload = useCallback(async (e) => {
//     //... (file upload logic is unchanged)
//   }, [addMessage]);

//   const sendMessage = useCallback(async () => {
//     const userMessage = inputText.trim();
//     if (!userMessage) return;
//     addMessage("user", userMessage);
//     setInputText("");

//     if (chatMode === 'kaas_conversation') {
//       setShowSuggestions(false);
//       setLoading(true);
//       setTimeout(() => {
//         if (askingName) {
//           setUserName(userMessage);
//           setAskingName(false);
//           addMessage("bot", `It's a pleasure to meet you, ${userMessage}! How can I help you with KaaS today? You can ask me about our courses, certifications, and more.`);
//           setShowSuggestions(true);
//         } else {
//           const response = getKaaSResponse(userMessage);
//           addMessage("bot", response);
//           setTimeout(() => {
//             addMessage("bot", "Is there anything else I can help you with?");
//             setShowSuggestions(true);
//           }, 1500);
//         }
//         setLoading(false);
//       }, 800);
//     }

//     if (chatMode === 'pdf_qa' && pdfId) {
//       setLoading(true);
//       try {
//         const res = await axios.post("https://tdtlworld.com/tatademo-backend/diagnostic/pdf/ask/", { pdf_id: pdfId, question: userMessage });
//         addMessage("bot", res.data, 'structured');
//       } catch (err) {
//         addMessage("bot", "❌ Failed to get an answer. Please try again.");
//       } finally {
//         setLoading(false);
//       }
//     }
//   }, [addMessage, inputText, chatMode, pdfId, askingName, getKaaSResponse]);

//   const toggleChat = useCallback(() => {
//     if (!isOpen) {
//       clearChat();
//     }
//     setIsOpen(prev => !prev);
//   }, [isOpen, clearChat]);

//   const handleKeyPress = useCallback((e) => {
//     if (e.key === "Enter") sendMessage();
//   }, [sendMessage]);

//   useEffect(() => {
//     messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
//   }, [messages, loading, typingEffect.text]);

//   const getPlaceholderText = () => {
//     if (chatMode === 'pdf_qa' && pdfId) return "Ask about the document...";
//     if (chatMode === 'kaas_conversation') {
//       return askingName ? "Please enter your name..." : "Ask about KaaS features...";
//     }
//     return "Select an option to begin...";
//   }

//   return (
//     <>
//       <ComponentStyles />
//       <div className="kaas-chatbot-container">
//         {!isOpen && <div className="chatbot-fab" onClick={toggleChat}><i className="fas fa-robot" style={{ fontSize: "24px" }}></i></div>}
//         {isOpen && (
//           <div className="chatbot-window">
//             <header className="chatbot-header">
//               <div className="header-info">
//                 <BotAvatar isSpeaking={isSpeaking} />
//                 <div>
//                   <div className="header-title">KaaS Assistant</div>
//                   <div className="header-status">
//                     {chatMode === 'selection' && 'Awaiting Selection'}
//                     {chatMode === 'kaas_conversation' && 'KaaS Conversation'}
//                     {chatMode === 'pdf_qa' && 'Document Analysis'}
//                   </div>
//                 </div>
//               </div>
//               <div className="header-buttons">
//                 <button onClick={clearChat} title="Restart Chat" className="header-btn"><i className="fas fa-redo"></i></button>
//                 <button onClick={toggleChat} title="Close Chat" className="header-btn"><i className="fas fa-times"></i></button>
//               </div>
//             </header>

//             <main className="messages-container">
//               {messages.map((msg, index) => <Message key={index} msg={msg} isLast={index === messages.length - 1} typingText={typingEffect.text} />)}
//               {loading && ( <div className="message-wrapper bot"> <div className="message-info bot"><BotAvatar/></div> <ThreeDots height="40" width="40" color="#b8529e" /> </div> )}
//               {showSuggestions && ( <div className="suggestions-container"> {suggestions.map((s, i) => ( <button key={i} onClick={() => {setInputText(s); setTimeout(sendMessage, 100);}} className="suggestion-btn">{s}</button> ))} </div> )}
//               <div ref={messagesEndRef} />
//             </main>

//             <footer className="input-area">
//               {chatMode !== 'selection' && (
//                 <div className="input-wrapper">
//                   {chatMode === 'pdf_qa' && !pdfId ? (
//                     <label className="upload-label"><i className="fas fa-upload"></i> Upload PDF <input type="file" accept="application/pdf" onChange={handleFileUpload} ref={fileInputRef} hidden /></label>
//                   ) : (
//                     <>
//                       <input type="text" value={inputText} onChange={(e) => setInputText(e.target.value)} onKeyPress={handleKeyPress} placeholder={getPlaceholderText()} className="input-field"/>
//                       <button onClick={sendMessage} className="send-btn"><i className="fas fa-paper-plane"></i></button>
//                     </>
//                   )}
//                 </div>
//               )}
//             </footer>
//           </div>
//         )}
//       </div>
//     </>
//   );
// };

// export default KaaSChatbot;

import React, { useState, useEffect, useRef, useCallback } from "react";
import { ThreeDots } from "react-loader-spinner";
import "@fortawesome/fontawesome-free/css/all.min.css";
import axios from "axios";

// +------------------------------------------------------------------+
// |           Step 1: Centralized Stylesheet Component               |
// +------------------------------------------------------------------+
const ComponentStyles = () => (
  <style>{`
    /* --- Animations --- */
    @keyframes pulse { 0% { transform: translate(-50%, -50%) scale(0.8); } 50% { transform: translate(-50%, -50%) scale(1.2); } 100% { transform: translate(-50%, -50%) scale(0.8); } }
    @keyframes bounce { 0%, 100% { transform: translateY(0); } 50% { transform: translateY(-10px); } }
    @keyframes slideIn { from { opacity: 0; transform: translateY(20px); } to { opacity: 1; transform: translateY(0); } }
    @keyframes fadeIn { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: translateY(0); } }
    @keyframes blink { 50% { opacity: 0; } }

    /* --- Core Chatbot Structure --- */
    .kaas-chatbot-container { 
      position: fixed; 
      bottom: 20px; 
      right: 20px; 
      z-index: 9999; 
      font-family: 'Outfit', 'Segoe UI', sans-serif; 
    }
    .chatbot-fab { 
      background: linear-gradient(45deg, #D4AF37 30%, #F5D76E 90%); 
      color: #ffffff; 
      width: 60px; 
      height: 60px; 
      border-radius: 50%; 
      display: flex; 
      align-items: center; 
      justify-content: center; 
      cursor: pointer; 
      box-shadow: 0 4px 15px rgba(212, 175, 55, 0.4); 
      animation: bounce 2s infinite; 
      transition: transform 0.2s ease, box-shadow 0.2s ease; 
    }
    .chatbot-fab:hover { 
      transform: scale(1.1); 
      animation-play-state: paused; 
      box-shadow: 0 6px 20px rgba(212, 175, 55, 0.6);
    }
    .chatbot-window { 
      width: 370px; 
      height: 600px; 
      background: #FFFFFF; 
      box-shadow: 0 10px 40px rgba(0,0,0,0.15); 
      border: 1px solid rgba(212, 175, 55, 0.2);
      border-radius: 20px; 
      overflow: hidden; 
      display: flex; 
      flex-direction: column; 
      animation: slideIn 0.3s ease-out; 
    }

    /* --- Chatbot Header --- */
    .chatbot-header { 
      background: linear-gradient(45deg, #D4AF37 30%, #F5D76E 90%); 
      color: #0D0D0D; 
      padding: 15px 20px; 
      display: flex; 
      align-items: center; 
      justify-content: space-between; 
      flex-shrink: 0; 
      box-shadow: 0 2px 10px rgba(0,0,0,0.1);
    }
    .header-info { display: flex; align-items: center; gap: 12px; }
    .header-title { font-weight: bold; font-size: 16px; color: #0D0D0D; }
    .header-status { font-size: 12px; opacity: 0.8; color: #0D0D0D; }
    .header-buttons { display: flex; gap: 8px; }
    .header-btn { 
      background: rgba(13, 13, 13, 0.1); 
      border: none; 
      color: #0D0D0D; 
      cursor: pointer; 
      width: 32px; 
      height: 32px; 
      border-radius: 50%; 
      display: flex; 
      align-items: center; 
      justify-content: center; 
      transition: background-color 0.2s ease; 
    }
    .header-btn:hover { background: rgba(13, 13, 13, 0.2); }

    /* --- Messages Area --- */
    .messages-container { 
      flex-grow: 1; 
      overflow-y: auto; 
      padding: 15px; 
      display: flex; 
      flex-direction: column; 
      background: #F8F9FA;
    }
    .message-wrapper { display: flex; flex-direction: column; margin-bottom: 20px; max-width: 85%; animation: fadeIn 0.4s ease-out; }
    .message-wrapper.user { align-self: flex-end; }
    .message-wrapper.bot { align-self: flex-start; }
    .message-bubble { padding: 12px 18px; border-radius: 18px; line-height: 1.5; font-size: 14px; word-wrap: break-word; position: relative; }
    .message-bubble.bot { 
      background: #FFFFFF; 
      color: #333; 
      border-top-left-radius: 4px; 
      box-shadow: 0 2px 5px rgba(0,0,0,0.05); 
      border: 1px solid rgba(0,0,0,0.05);
    }
    .message-bubble.user { 
      background: linear-gradient(45deg, #D4AF37 30%, #F5D76E 90%); 
      color: #0D0D0D; 
      border-top-right-radius: 4px; 
      box-shadow: 0 4px 10px rgba(212, 175, 55, 0.2);
      font-weight: 500;
    }
    .message-info { font-size: 0.8em; margin-top: 5px; color: #999; }
    .message-info.user { text-align: right; margin-right: 5px; }
    .message-info.bot { display: flex; align-items: center; gap: 8px; font-weight: bold; color: #D4AF37; margin-bottom: 5px; }
    
    /* --- Bot Avatar --- */
    .bot-avatar { 
      width: 32px; 
      height: 32px; 
      border-radius: 50%; 
      background: linear-gradient(45deg, #D4AF37 30%, #F5D76E 90%); 
      display: flex; 
      align-items: center; 
      justify-content: center; 
      position: relative; 
      box-shadow: 0 2px 8px rgba(212, 175, 55, 0.3); 
      flex-shrink: 0; 
    }
    .bot-avatar-inner { width: 16px; height: 16px; border-radius: 50%; background-color: #fff; position: relative; }
    .bot-avatar-pulse { 
      position: absolute; 
      top: 50%; 
      left: 50%; 
      width: 8px; 
      height: 8px; 
      background: #D4AF37; 
      border-radius: 50%; 
      transform: translate(-50%, -50%); 
    }
    .bot-avatar-pulse.speaking { animation: pulse 1s infinite; }
    
    /* --- Typing Indicator --- */
    .typing-cursor { display: inline-block; background-color: #0D0D0D; width: 2px; height: 1em; animation: blink 1s step-end infinite; }

    /* --- Input Area --- */
    .input-area { padding: 15px; background: #fff; border-top: 1px solid #e0e0e0; flex-shrink: 0; box-shadow: 0 -2px 10px rgba(0,0,0,0.05); }
    .input-wrapper { display: flex; align-items: center; gap: 10px; }
    .input-field { border: 1px solid #ddd; outline: none; flex-grow: 1; padding: 12px; font-size: 14px; border-radius: 12px; transition: border-color 0.2s, box-shadow 0.2s; }
    .input-field:focus { border-color: #D4AF37; box-shadow: 0 0 0 2px rgba(212, 175, 55, 0.2); }
    .send-btn { 
      background: linear-gradient(45deg, #D4AF37 30%, #F5D76E 90%); 
      color: #0D0D0D; 
      border: none; 
      border-radius: 50%; 
      width: 44px; 
      height: 44px; 
      display: flex; 
      align-items: center; 
      justify-content: center; 
      cursor: pointer; 
      transition: transform 0.2s, box-shadow 0.2s; 
      box-shadow: 0 2px 8px rgba(212, 175, 55, 0.2);
    }
    .send-btn:hover { transform: scale(1.05); box-shadow: 0 4px 12px rgba(212, 175, 55, 0.4); }

    /* --- Special UI Elements --- */
    .upload-label { 
      background: linear-gradient(45deg, #D4AF37 30%, #F5D76E 90%); 
      color: #0D0D0D; 
      padding: 12px; 
      border-radius: 12px; 
      cursor: pointer; 
      display: flex; 
      align-items: center; 
      justify-content: center; 
      gap: 8px; 
      font-weight: 500; 
      text-align: center; 
      box-shadow: 0 2px 8px rgba(212, 175, 55, 0.2);
    }
    .suggestions-container { display: flex; flex-wrap: wrap; gap: 8px; margin-top: 15px; animation: fadeIn 0.5s; }
    .suggestion-btn { 
      background: rgba(212, 175, 55, 0.1); 
      border: 1px solid rgba(212, 175, 55, 0.3); 
      border-radius: 20px; 
      padding: 8px 16px; 
      font-size: 13px; 
      color: #B8860B; 
      cursor: pointer; 
      transition: all 0.2s ease; 
      font-weight: 500;
    }
    .suggestion-btn:hover { background: rgba(212, 175, 55, 0.2); color: #0D0D0D; }
    .mode-selection-btn { 
      background: #fff; 
      border: 1px solid #D4AF37; 
      color: #D4AF37; 
      padding: 12px; 
      border-radius: 12px; 
      cursor: pointer; 
      text-align: left; 
      font-weight: bold; 
      transition: all 0.2s ease; 
      width: 100%; 
      display: flex; 
      align-items: center; 
      gap: 10px; 
      font-size: 14px; 
    }
    .mode-selection-btn:hover { background-color: #D4AF37; color: #fff; transform: translateY(-2px); box-shadow: 0 4px 12px rgba(212, 175, 55, 0.2); }
    
    /* --- Styles for Parsed JSON Response --- */
    .structured-response-card { background: white; border: 1px solid rgba(212, 175, 55, 0.2); border-radius: 15px; font-size: 0.9rem; width: 100%; box-shadow: 0 4px 15px rgba(0,0,0,0.05); overflow: hidden; }
    .structured-response-header { padding: 15px; background: rgba(212, 175, 55, 0.03); }
    .structured-response-header p { margin: 0 0 8px 0; line-height: 1.4; }
    .structured-response-header strong { color: #B8860B; }
    .structured-response-details { padding: 15px; font-size: 0.85rem; max-height: 250px; overflow-y: auto; border-top: 1px solid rgba(212, 175, 55, 0.1); }
    .details-section { margin-bottom: 15px; }
    .details-section h4 { margin: 0 0 8px 0; color: #D4AF37; font-size: 0.85rem; text-transform: uppercase; display: flex; align-items: center; letter-spacing: 0.05em; }
    .details-section ul { list-style: none; padding-left: 0; margin: 0; }
    .details-section li { padding: 4px 0 4px 20px; position: relative; line-height: 1.4; color: #555; }
    .details-section li::before { content: '›'; position: absolute; left: 4px; color: #D4AF37; font-weight: bold; font-size: 1.2rem; top: 0px; }
    .toggle-details-btn { background-color: #f8f9fa; border: none; color: #B8860B; width: 100%; text-align: center; padding: 10px; cursor: pointer; font-weight: 600; font-size: 0.85rem; border-top: 1px solid rgba(212, 175, 55, 0.1); transition: all 0.2s; }
    .toggle-details-btn:hover { background-color: rgba(212, 175, 55, 0.05); color: #D4AF37; }
  `}</style>
);

// +------------------------------------------------------------------+
// |    Step 2: Extracted and Memoized Child Components               |
// +------------------------------------------------------------------+

const ParsedJsonResponse = React.memo(({ data }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const {
    answer,
    possible_causes,
    tools_required,
    parts_needed,
    fault_code,
    system,
    description,
    repair_steps,
  } = data;

  const hasDetailsToShow =
    possible_causes?.length > 0 ||
    tools_required?.length > 0 ||
    parts_needed?.length > 0 ||
    repair_steps?.length > 0;

  const DetailSection = ({ title, icon, items }) => {
    if (!items || items.length === 0) return null;
    return (
      <div className="details-section">
        <h4>
          <i className={`fas ${icon}`} style={{ marginRight: "6px" }}></i>
          {title}
        </h4>
        <ul>
          {items.map((item, idx) => (
            <li key={idx}>{item}</li>
          ))}
        </ul>
      </div>
    );
  };

  return (
    <div className="structured-response-card">
      <div className="structured-response-header">
        {answer && (
          <p>
            <strong>Answer:</strong> {answer}
          </p>
        )}
        {fault_code && (
          <p>
            <strong>Fault Code:</strong> {fault_code}
          </p>
        )}
        {system && (
          <p>
            <strong>System:</strong> {system}
          </p>
        )}
        {description && (
          <p>
            <strong>Description:</strong> {description}
          </p>
        )}
      </div>
      {isExpanded && (
        <div className="structured-response-details">
          <DetailSection
            title="Possible Causes"
            icon="fa-exclamation-triangle"
            items={possible_causes}
          />
          <DetailSection
            title="Tools Required"
            icon="fa-wrench"
            items={tools_required}
          />
          <DetailSection
            title="Parts Needed"
            icon="fa-cogs"
            items={parts_needed}
          />
          <DetailSection
            title="Repair Steps"
            icon="fa-clipboard-list"
            items={repair_steps}
          />
        </div>
      )}
      {hasDetailsToShow && (
        <button
          className="toggle-details-btn"
          onClick={() => setIsExpanded(!isExpanded)}
        >
          {isExpanded ? "Hide Full Analysis" : "Show Full Analysis"}
        </button>
      )}
    </div>
  );
});

const BotAvatar = React.memo(({ isSpeaking }) => (
  <div className="bot-avatar">
    <div className="bot-avatar-inner">
      <div className={`bot-avatar-pulse ${isSpeaking ? "speaking" : ""}`} />
    </div>
  </div>
));

const Message = React.memo(({ msg, isLast, typingText }) => {
  const isBot = msg.sender === "bot";

  if (isBot && msg.type === "selection") {
    return (
      <div className="message-wrapper bot">
        <div className="message-info bot">
          <BotAvatar />
          <p>KaaS Advisor</p>
        </div>
        <div className="message-bubble bot">
          <p style={{ margin: "0 0 15px 0", fontSize: "15px" }}>
            {msg.content}
          </p>
          <div
            style={{ display: "flex", flexDirection: "column", gap: "10px" }}
          >
            <button onClick={msg.onSelectKaas} className="mode-selection-btn">
              <i className="fas fa-comments" style={{ color: "#D4AF37" }}></i>
              Chat about KaaS
            </button>
            <button onClick={msg.onSelectPdf} className="mode-selection-btn">
              <i className="fas fa-file-alt" style={{ color: "#D4AF37" }}></i>
              Analyze a Document
            </button>
          </div>
        </div>
      </div>
    );
  }

  let parsedData = null,
    fallbackText = "";
  if (isBot && msg.type === "structured") {
    parsedData = msg.content;
  } else {
    fallbackText = msg.content;
  }

  return (
    <div className={`message-wrapper ${isBot ? "bot" : "user"}`}>
      {isBot && (
        <div className="message-info bot">
          <BotAvatar />
          <p>KaaS Advisor</p>
        </div>
      )}
      {parsedData ? (
        <ParsedJsonResponse data={parsedData} />
      ) : (
        <div className={`message-bubble ${isBot ? "bot" : "user"}`}>
          {isLast && isBot && typingText ? typingText : fallbackText}
          {isLast && isBot && typingText && <span className="typing-cursor" />}
        </div>
      )}
      {!isBot && <div className="message-info user">You</div>}
    </div>
  );
});

// +------------------------------------------------------------------+
// |        Step 3: The Main, Optimized Chatbot Component             |
// +------------------------------------------------------------------+
const KaaSChatbot = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [messages, setMessages] = useState([]);
  const [inputText, setInputText] = useState("");
  const [loading, setLoading] = useState(false);
  const [chatMode, setChatMode] = useState("selection");
  const [userName, setUserName] = useState("");
  const [askingName, setAskingName] = useState(true);
  const [isSpeaking, setIsSpeaking] = useState(false);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [typingEffect, setTypingEffect] = useState({ active: false, text: "" });
  const [pdfId, setPdfId] = useState(null);

  const messagesEndRef = useRef(null);
  const fileInputRef = useRef(null);

  const kaasKnowledgeBase = {
    introduction:
      "KaaS (Knowledge as a Service) is a premier learning platform from Vetrina Healthcare, designed for the animal health industry. We offer expert-led courses in dairy, poultry, and companion animal sectors to empower professionals and entrepreneurs.",
    course:
      "Our courses cover a wide range of topics including animal nutrition, disease management, and business development. They are designed by industry veterans with practical, real-world applications in mind. Which specific area interests you?",
    certification:
      "Yes, we offer professional certifications upon successful completion of our learning paths. These are recognized within the industry and help validate your skills for career advancement.",
    price:
      "Our pricing varies depending on the course or learning path. We offer individual course purchases as well as subscription plans for comprehensive access. Please visit our official website for the latest pricing details.",
    support:
      "For any assistance, you can reach our support team via email at KaaS@vetrinahealthcare.com or call us at +91 8600844450. We're here to help you on your learning journey.",
    default:
      "That's an interesting question. I can provide detailed information about our courses, certifications, pricing, or support. How can I best assist you?",
  };
  const suggestions = [
    "Our Courses",
    "Certifications",
    "Pricing",
    "Contact Support",
  ];

  const getKaaSResponse = useCallback(
    (userInput) => {
      const lowerInput = userInput.toLowerCase();
      if (lowerInput.includes("course") || lowerInput.includes("module"))
        return kaasKnowledgeBase.course;
      if (lowerInput.includes("certifica"))
        return kaasKnowledgeBase.certification;
      if (lowerInput.includes("price") || lowerInput.includes("cost"))
        return kaasKnowledgeBase.price;
      if (
        lowerInput.includes("support") ||
        lowerInput.includes("contact") ||
        lowerInput.includes("help")
      )
        return kaasKnowledgeBase.support;
      if (lowerInput.includes("kaas") || lowerInput.includes("about"))
        return kaasKnowledgeBase.introduction;
      return kaasKnowledgeBase.default;
    },
    [kaasKnowledgeBase],
  );

  const speak = useCallback((text) => {
    if (typeof text !== "string" || !window.speechSynthesis) return;
    speechSynthesis.cancel();
    setIsSpeaking(true);
    const utterance = new SpeechSynthesisUtterance(text);
    const voices = speechSynthesis.getVoices();
    const femaleVoice = voices.find(
      (v) => v.lang === "en-US" && v.name.includes("Female"),
    );
    if (femaleVoice) utterance.voice = femaleVoice;
    utterance.onend = () => setIsSpeaking(false);
    speechSynthesis.speak(utterance);
  }, []);

  const addMessage = useCallback((sender, content, type = "text") => {
    setMessages((prev) => [...prev, { sender, content, type }]);
  }, []);

  const handleModeSelection = useCallback(
    (mode) => {
      addMessage(
        "user",
        mode === "kaas" ? "Chat about KaaS" : "Analyze a Document",
      );
      if (mode === "kaas") {
        setChatMode("kaas_conversation");
        setAskingName(true);
        setTimeout(
          () =>
            addMessage(
              "bot",
              "Great choice! I'm Ms. Kawan, your guide to KaaS. To personalize our chat, what is your name?",
            ),
          500,
        );
      } else {
        setChatMode("pdf_qa");
        setTimeout(
          () =>
            addMessage(
              "bot",
              "Excellent. Please upload your technical PDF to begin the analysis.",
            ),
          500,
        );
      }
    },
    [addMessage],
  );

  const clearChat = useCallback(() => {
    setMessages([
      {
        sender: "bot",
        content: "Welcome to the KaaS Assistant! How can I help you today?",
        type: "selection",
        onSelectKaas: () => handleModeSelection("kaas"),
        onSelectPdf: () => handleModeSelection("pdf"),
      },
    ]);
    setChatMode("selection");
    setInputText("");
    setPdfId(null);
    setUserName("");
    setAskingName(true);
    setShowSuggestions(false);
    if (window.speechSynthesis) window.speechSynthesis.cancel();
  }, [handleModeSelection]);

  const handleFileUpload = useCallback(
    async (e) => {
      const file = e.target.files[0];
      if (!file) return;
      addMessage("user", `📂 ${file.name}`);
      setLoading(true);
      const formData = new FormData();
      formData.append("file", file);
      try {
        const res = await axios.post(
          "https://tdtlworld.com/tatademo-backend/diagnostic/pdf/upload/",
          formData,
          { headers: { "Content-Type": "multipart-form-data" } },
        );
        setPdfId(res.data?.pdf_id);
        addMessage(
          "bot",
          "✅ File uploaded successfully! You can now ask questions about it.",
        );
      } catch (err) {
        addMessage("bot", "❌ Upload failed. Please try again.");
      } finally {
        setLoading(false);
        if (fileInputRef.current) fileInputRef.current.value = "";
      }
    },
    [addMessage],
  );

  const sendMessage = useCallback(async () => {
    const userMessage = inputText.trim();
    if (!userMessage) return;
    addMessage("user", userMessage);
    setInputText("");

    if (chatMode === "kaas_conversation") {
      setShowSuggestions(false);
      setLoading(true);
      setTimeout(() => {
        if (askingName) {
          setUserName(userMessage);
          setAskingName(false);
          addMessage(
            "bot",
            `It's a pleasure to meet you, ${userMessage}! How can I help you with KaaS today? You can ask me about our courses, certifications, and more.`,
          );
          setShowSuggestions(true);
        } else {
          const response = getKaaSResponse(userMessage);
          addMessage("bot", response);
          setTimeout(() => {
            addMessage("bot", "Is there anything else I can help you with?");
            setShowSuggestions(true);
          }, 1500);
        }
        setLoading(false);
      }, 800);
    }

    if (chatMode === "pdf_qa" && pdfId) {
      setLoading(true);
      try {
        const res = await axios.post(
          "https://tdtlworld.com/tatademo-backend/diagnostic/pdf/ask/",
          { pdf_id: pdfId, question: userMessage },
        );
        addMessage("bot", res.data, "structured");
      } catch (err) {
        addMessage("bot", "❌ Failed to get an answer. Please try again.");
      } finally {
        setLoading(false);
      }
    }
  }, [addMessage, inputText, chatMode, pdfId, askingName, getKaaSResponse]);

  const toggleChat = useCallback(() => {
    if (!isOpen) {
      clearChat();
    }
    setIsOpen((prev) => !prev);
  }, [isOpen, clearChat]);

  const handleKeyPress = useCallback(
    (e) => {
      if (e.key === "Enter") sendMessage();
    },
    [sendMessage],
  );

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages, loading, typingEffect.text]);

  const getPlaceholderText = () => {
    if (chatMode === "pdf_qa" && !pdfId) return "Upload a document to begin...";
    if (chatMode === "pdf_qa" && pdfId) return "Ask about the document...";
    if (chatMode === "kaas_conversation") {
      return askingName
        ? "Please enter your name..."
        : "Ask about KaaS features...";
    }
    return "Select an option to begin...";
  };

  return (
    <>
      <ComponentStyles />
      <div className="kaas-chatbot-container">
        {!isOpen && (
          <div className="chatbot-fab" onClick={toggleChat}>
            <i className="fas fa-robot" style={{ fontSize: "24px", color: "#ffffff" }}></i>
          </div>
        )}
        {isOpen && (
          <div className="chatbot-window">
            <header className="chatbot-header">
              <div className="header-info">
                <BotAvatar isSpeaking={isSpeaking} />
                <div>
                  <div className="header-title">KaaS Assistant</div>
                  <div className="header-status">
                    {chatMode === "selection" && "Awaiting Selection"}
                    {chatMode === "kaas_conversation" && "KaaS Conversation"}
                    {chatMode === "pdf_qa" && "Document Analysis"}
                  </div>
                </div>
              </div>
              <div className="header-buttons">
                <button
                  onClick={clearChat}
                  title="Restart Chat"
                  className="header-btn"
                >
                  <i className="fas fa-redo"></i>
                </button>
                <button
                  onClick={toggleChat}
                  title="Close Chat"
                  className="header-btn"
                >
                  <i className="fas fa-times"></i>
                </button>
              </div>
            </header>

            <main className="messages-container">
              {messages.map((msg, index) => (
                <Message
                  key={index}
                  msg={msg}
                  isLast={index === messages.length - 1}
                  typingText={typingEffect.text}
                />
              ))}
              {loading && (
                <div className="message-wrapper bot">
                  {" "}
                  <div className="message-info bot">
                    <BotAvatar />
                  </div>{" "}
                  <ThreeDots height="40" width="40" color="#b8529e" />{" "}
                </div>
              )}
              {showSuggestions && (
                <div className="suggestions-container">
                  {" "}
                  {suggestions.map((s, i) => (
                    <button
                      key={i}
                      onClick={() => {
                        setInputText(s);
                        setTimeout(sendMessage, 100);
                      }}
                      className="suggestion-btn"
                    >
                      {s}
                    </button>
                  ))}{" "}
                </div>
              )}
              <div ref={messagesEndRef} />
            </main>

            <footer className="input-area">
              <div className="input-wrapper">
                {chatMode === "pdf_qa" && !pdfId ? (
                  <label className="upload-label">
                    <i className="fas fa-upload"></i> Upload PDF{" "}
                    <input
                      type="file"
                      accept="application/pdf"
                      onChange={handleFileUpload}
                      ref={fileInputRef}
                      hidden
                    />
                  </label>
                ) : (
                  <>
                    <input
                      type="text"
                      value={inputText}
                      onChange={(e) => setInputText(e.target.value)}
                      onKeyPress={handleKeyPress}
                      placeholder={getPlaceholderText()}
                      className="input-field"
                      disabled={chatMode === "selection"}
                    />
                    <button
                      onClick={sendMessage}
                      className="send-btn"
                      disabled={chatMode === "selection"}
                    >
                      <i className="fas fa-paper-plane"></i>
                    </button>
                  </>
                )}
              </div>
            </footer>
          </div>
        )}
      </div>
    </>
  );
};

export default KaaSChatbot;
